{
    "Anonymous.NotAvailable.Heading": "Niet beschikbaar",
    "Anonymous.NotAvailable.Body": "Dit webinar is niet beschikbaar voor anonieme kijkers.",

    "Account.ApiErrorCode.Exception": "Er is iets verkeerd gegaan",
    "Account.ApiErrorCode.NotFoundException": "Account niet gevonden.",
    "Account.ApiErrorCode.AccessDeniedException": "Ongeldig e-mailadres of wachtwoord.",
    "Account.ApiErrorCode.AccountNotVerifiedException": "Account is niet geverifieerd",
    "Account.ApiErrorCode.ConflictException": "Account bestaat al",
    "Account.ApiErrorCode.LockedOutException": "Account is vergrendeld. Reset uw wachtwoord om weer toegang te krijgen.",
    "Account.ApiErrorCode.ThrottledException": "Te veel pogingen vanaf uw netwerk. Probeer het later nog eens.",
    "Account.ApiErrorCode.AccountLinkCodeInvalidException": "Ongeldige code",
    "Account.ApiErrorCode.AccountLinkCodeAlreadyUsedException": "Code is al gebruikt",
    "Account.ApiErrorCode.AccountLinkCodeExpiredException": "Code is verlopen",
    "Account.ApiErrorCode.ImageFormatException": "Ongeldige bestandstype afbeelding",
    "Account.Bar.Text": "Account beheren van",
    "Account.Button": "Mijn account",
    "Account.Button.ForgotPassword": "Wachtwoord vergeten",
    "Account.Button.ChangePassword": "Wachtwoord veranderen",
    "Account.Button.ResetPassword": "Reset wachtwoord",
    "Account.Button.ShowPassword": "Wachtwoord tonen",
    "Account.Button.HidePassword": "Wachtwoord verbergen",
    "Account.Button.Login": "Login",
    "Account.Button.Register": "Registreren",
    "Account.Button.Next": "Volgende",
    "Account.Button.Back": "Terug",
    "Account.Button.Cancel": "Annuleer",
    "Account.Images.Button.DeleteBannerImage.AriaLabel": "Bannerafbeelding verwijderen",
    "Account.Images.Button.DeleteProfileImage.AriaLabel": "Profielafbeelding verwijderen",
    "Account.Images.Button.UploadBannerImage.AriaLabel": "Bannerafbeelding uploaden",
    "Account.Images.Button.UploadProfileImage.AriaLabel": "Profielafbeelding uploaden",
    "Account.Images.Label": "Standaard webinar profiel en banner afbeelding",

    "AccountInvite.Button.Reject": "Uitnodiging afwijzen",
    "AccountInvite.Info": "U bent uitgenodigd om deel te nemen aan dit webinar platform. Vul uw gegevens in om een ​​account aan te maken. U kunt de uitnodiging ook afwijzen.",
    "AccountInvite.PageHeading": "U bent uitgenodigd",
    "AccountInvite.AccountLinkCodeAlreadyUsedException": "U heeft al een account bij ons",
    "AccountInvite.AccountLinkCodeAlreadyUsedException.Body": "Er is al een account gekoppeld aan deze uitnodigingslink. Als u uw wachtwoord bent vergeten, kunt u de functie 'Wachtwoord vergeten' gebruiken tijdens het inloggen.",

    "AccountInvites.PageHeading": "Deelnemers uitnodigen voor uw omgeving",

    "Account.Management.Button.Invite": "Uitnodigen",
    "Account.Management.Button.RemoveAccount": "Verwijder {{account}}",
    "Account.Management.Heading.InvitedAccounts": "Uitgenodigde leden",
    "Account.Management.InfoText": "Hier kunt u andere personen uitnodigen om uw webinars te managen. Zij kunnen vervolgens: <ul><li>Webinars aanmaken en bewerken</li><li>Inzichten (statistieken) bekijken</li><li>Webinars modereren</li><li>Webinars uitzenden</li></ul><br>Om iemand uit te nodigen vult u het e-mail adres in van degene die u wilt uitnodigen. Er wordt dan een e-mail verstuurd naar de betreffende persoon.",
    "Account.Management.PageHeading": "Account beheren",
    "Account.Management.InviteStatus.Accepted": "geaccepteerd",
    "Account.Management.InviteStatus.Pending": "in behandeling",
    "Account.Management.InviteStatus.Rejected": "afgewezen",
    "Account.Label.FirstName": "Voornaam",
    "Account.Label.LastName": "Achternaam",
    "Account.Label.Nickname": "Nickname",
    "Account.Label.CompanyName": "Bedrijfsnaam",
    "Account.Label.Country": "Land",
    "Account.Label.Email": "E-mail",
    "Account.Label.Password": "Wachtwoord",
    "Account.Label.ForgotPasswordCode": "Wachtwoord vergeten code",
    "Account.Label.CurrentPassword": "Huidig wachtwoord",
    "Account.Label.NewPassword": "Nieuw wachtwoord",
    "Account.Label.TermsAndConditions1": "Ik ga akkoord met de ",
    "Account.Label.TermsAndConditions2": "algemene voorwaarden",
    "Account.Link.TermsAndConditions": "https://www.onlinewebinar.com/nl/bedrijf/terms-of-service",
    "Account.Menu.Logout": "Uitloggen",
    "Account.Menu.ManageAccount": "Account beheren",
    "Account.Menu.NotOnMainAccount": "Account gegevens zijn niet beschikbaar tijdens het beheren van een ander account",
    "Account.Menu.Password": "Mijn wachtwoord",
    "Account.Menu.Profile": "Mijn profiel",
    "Account.Menu.SwitchAccount": "Wissel account",
    "Account.Menu.Welcome": "Welkom terug",
    "Account.Message.SendingEmail": "E-mail versturen aan <strong>{{email}}</strong>",
    "Account.Message.ErrorSendingEmail": "Er is iets verkeerd gegaan tijdens het versturen van de e-mail aan <strong>{{email}}</strong>. Probeer het zo meteen nog een keer.",
    "Account.Message.EmailSent": "Een e-mail is verstuurd naar <strong>{{email}}</strong> met de code om je wachtwoord te resetten.",
    "Account.Message.PasswordChanged": "Je wachtwoord is aangepast.",
    "Account.Password.Changed.Message": "Het wachtwoord van uw account is met succes aangepast.",
    "Account.Password.PageHeading": "Mijn wachtwoord",
    "Account.Profile.Changed.Message": "Uw profiel is met succes aangepast.",
    "Account.Profile.PageHeading": "Mijn profiel",
    "Account.Profile.NotAvailable": "Profiel niet beschikbaar",
    "Account.Profile.NotAvailable.Body": "Uw accountprofiel is momenteel niet beschikbaar. Dit komt doordat u op dit moment een ander account beheert. Schakel terug naar uw eigen account om uw profielgegevens te bekijken en te bewerken.",
    "Account.Tab.ApiKeys": "API-sleutels",
    "Account.Tab.ManageAccount": "Account beheren",
    "Account.Tab.Password": "Wachtwoord",
    "Account.Tab.Profile": "Profiel",

    "Account.ApiKeys.PageHeading": "API-sleutels",
    "Account.ApiKeys.Description": "Met API-sleutels kunt u programmatisch toegang krijgen tot uw account. Houd ze geheim — iedereen met een sleutel kan namens u handelen.",
    "Account.ApiKeys.Label.Name": "Naam van de sleutel",
    "Account.ApiKeys.Button.Create": "API-sleutel aanmaken",
    "Account.ApiKeys.Button.Dismiss": "Sluiten",
    "Account.ApiKeys.Button.Revoke": "{{name}} intrekken",
    "Account.ApiKeys.Heading.ActiveKeys": "Actieve API-sleutels",
    "Account.ApiKeys.CreatedAt": "Aangemaakt op {{date}}",
    "Account.ApiKeys.Created.Title": "API-sleutel aangemaakt",
    "Account.ApiKeys.Created.Warning": "Kopieer deze sleutel nu — hij wordt niet opnieuw getoond.",
    "Account.ApiKeys.Validation.NameRequired": "Naam van de sleutel is vereist",

    "Account.Validation.EmailRequired": "E-mail adres is vereist",
    "Account.Validation.PasswordRequired": "Wachtwoord is vereist",
    "Account.Verification.Failed.Title": "Verificatie mislukt",
    "Account.Verification.Pending.Title": "Verifiëren",
    "Account.Verification.Required.Title": "Account verificatie is vereist",
    "Account.Verification.Required.Body": "Om door te gaan, klik op de link in de e-mail die we gestuurd hebben, en verrifier je account. Wil je een nieuwe verificatie email ontvangen? Klik op onderstaande button.",
    "Account.Verification.Required.Button": "Verstuur opnieuw de verificatie e-mail",
    "Account.Verification.Required.Error": "Er is iets verkeerd gegaan bij het versturen van de verificatie e-mail. Probeer het zo meteen nog eens.",
    "Account.Verification.Required.Success": "Een nieuwe verificatie e-mail is verstuurd naar je e-mail adres. Mocht je de e-mail niet kunnen vinden in je mailbox, kijk ajb ook even in je SPAM folder.",
    "Account.Verification.Succeeded.Heading": "Geverifieerd",
    "Account.Verification.Succeeded.Subheading": "Bedankt!",
    "Account.Verification.Succeeded.Text": "Uw account is nu geverifieerd en u kunt de volledige functionaliteit van de app gebruiken.",
    "Account.DeleteAccount.Button": "Account verwijderen",
    "Account.DeleteAccount.Confirm.Body": "Dit verwijdert uw account en alle bijbehorende gegevens permanent. U wordt onmiddellijk uitgelogd. Dit kan niet ongedaan gemaakt worden.",
    "Account.DeleteAccount.Confirm.Button": "Ja, account verwijderen",
    "Account.DeleteAccount.Confirm.Title": "Uw account verwijderen?",
    "Account.DeleteAccount.PageHeading": "Account verwijderen",
    "Account.DeleteAccount.Warning": "Verwijdert uw account, inloggegevens en alle accountbeheerkoppelingen permanent. Webinardeelname-geschiedenis blijft bewaard. Deze actie kan niet ongedaan gemaakt worden.",

    "AccountManagerInvite.Button.AcceptInvite": "Uitnodiging accepteren",
    "AccountManagerInvite.Button.RejectInvite": "Uitnodiging afwijzen",
    "AccountManagerInvite.InviteBody": "U bent uitgenodigd om webinars te beheren voor {{name}}. Verifieer eerst uw account, waarna u ons kunt laten weten of u de uitnodiging accepteert of weigert.",
    "AccountManagerInvite.InviteBodyVerified": "U bent uitgenodigd om webinars te beheren voor {{name}}. Laat het ons weten of u de uitnodiging accepteert of afwijst.",
    "AccountManagerInvite.InviteBody.CombineNameAndCompanyName": "{{name}} van {{companyName}}",
    "AccountManagerInvite.InviteUsed": "De uitnodigingslink is al gebruikt.",
    "AccountManagerInvite.Invalid": "De uitnodigingslink is niet geldig.",
    "AccountManagerInvite.InviteExpired": "Onze excuses, uw uitnodiging is verlopen. <1>Neem contact</1> op met {{name}} om een ​​nieuwe link aan te vragen.",
    "AccountManagerInvite.PageHeading": "Je bent uitgenodigd door {{account}}",

    "AccountSwitch.Button.SwitchAccount": "Wissel naar account {{account}}",
    "AccountSwitch.ManagedAccounts.Heading": "Managed accounts:",
    "AccountSwitch.PageHeading": "Wissel van account",
    "AccountSwitch.PersonalAccount.Heading": "Persoonlijk account:",

    "Beta.Heading": "Betafunctionaliteit",
    "Beta.Text.Icon": "Let op: bètafunctionaliteit",
    "Beta.Text.LiveTranscribe": "Live Transcribe bevindt zich nog in de bètafase, dus wees voorzichtig.",

    "Button.Back": "Terug naar de vorige pagina",
    "Button.BackToContent": "Terug naar de webinar content",
    "Button.BackToInsights": "Terug naar webinar inzichten",
    "Button.BackToManageEnv": "Terug naar beheer omgeving",
    "Button.BackToOrganized": "Terug naar komende webinars",
    "Button.BackToOrganizedEnded": "Terug naar afgelopen webinars",
    "Button.BackToOverview": "Terug naar het overzicht",
    "Button.BackToPoll": "Terug naar de poll",

    "Broadcaster.AudioAndVideoSelect.AudioSelect.label": "Selecteer een audioapparaat",
    "Broadcaster.AudioAndVideoSelect.Heading": "Selecteer een audio- en videoapparaat",
    "Broadcaster.AudioAndVideoSelect.IngestAvailability": "De ingest-URL is alleen beschikbaar tijdens het toegewezen tijdslot van <strong>{{timeslotstart}}</strong> tot <strong>{{timeslotend}}</strong>. Buiten dit tijdslot zal de verbinding mislukken.",
    "Broadcaster.AudioAndVideoSelect.Quality.label": "Videokwaliteit",
    "Broadcaster.AudioAndVideoSelect.Quality.High": "Hoog (1280×720, 4 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Medium": "Gemiddeld (1280×720, 2 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.Low": "Laag (854×480, 1 Mbit/s)",
    "Broadcaster.AudioAndVideoSelect.Quality.HighWarning": "<strong>Hoge kwaliteit</strong> vereist een snelle computer en een stabiele internetverbinding met veel bandbreedte. Kies Gemiddeld of Laag als het beeld hapert.",
    "Broadcaster.AudioAndVideoSelect.RTMP.Link": "De RTMP-URL:",
    "Broadcaster.AudioAndVideoSelect.RTMP.BaseLink": "De RTMP-BASEURL:",
    "Broadcaster.AudioAndVideoSelect.RTMP.StreamKey": "De RTMP-streamsleutel:",
    "Broadcaster.AudioAndVideoSelect.SRT.Link": "De SRT-URL:",
    "Broadcaster.AudioAndVideoSelect.SRT.StreamId": "De SRT stream ID:",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.Label": "Gebruik de klassieke verbinding (WebRTC)",
    "Broadcaster.AudioAndVideoSelect.UseClassicConnection.InfoText": "Standaard zenden we uit via Media over QUIC. Kies de klassieke verbinding als u problemen heeft met uw uitzending; uw keuze wordt in deze browser onthouden.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.label": "Selecteer een videoapparaat",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.RTMP": "RTMP-apparaat",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen": "Stop eerst uw externe encoder",
    "Broadcaster.AudioAndVideoSelect.ExternalIngestStillOpen.Body": "U schakelt over van een externe encoder naar uw browser. Als de encoder nog uitzendt, vechten beide om hetzelfde kanaal: uw kijkers zien het beeld steeds wegvallen en terugkomen totdat er één stopt. Stop de stream in uw encoder voordat u verdergaat.",
    "Broadcaster.AudioAndVideoSelect.FirefoxWebcamUnavailable": "Uitzenden met uw webcam is tijdelijk niet mogelijk in Firefox. We werken aan een oplossing, zodat u Firefox in de toekomst weer kunt gebruiken. Open deze pagina in de tussentijd in een andere browser, zoals Chrome, Edge of Safari, of zend uit met een externe encoder via RTMP of SRT.",
    "Broadcaster.AudioAndVideoSelect.VideoSelect.SRT": "SRT-apparaat",

    "Broadcaster.AccessDenied.Title": "Het webinar kan niet worden uitgezonden",
    "Broadcaster.AccessDenied": "U mag dit webinar niet uitzenden. Als u denkt dat dit een fout is, neem dan contact op met het supportteam van OnlineWebinar.com.",
    "Broadcaster.Error.Title": "Er is een fout opgetreden",
    "Broadcaster.Error": "Er is een fout opgetreden tijdens het uitzenden van het webinar. Probeer het later opnieuw of neem contact op met het supportteam van OnlineWebinar.com.",
    "Broadcaster.NoBooking.Title": "Tijdslot niet beschikbaar",
    "Broadcaster.NoBooking": "U kunt het webinar niet starten omdat er geen reservering voor dit webinar is. Controleer de details van de webinarreservering of neem contact op met het supportteam van OnlineWebinar.com voor hulp.",
    "Broadcaster.NoVideoPreview": "Voorbeeld niet beschikbaar",
    "Broadcaster.NotActivePresenter": "Er is momenteel een andere presentator aan het uitzenden. Wil je de actieve presentator worden?",
    "Broadcaster.UnsupportedBrowser.Title": "Niet-ondersteunde browser",
    "Broadcaster.UnsupportedBrowser": "Uw browser ondersteunt het uitzenden van webinars niet. Gebruik een moderne browser zoals Google Chrome, Mozilla Firefox, Microsoft Edge of Safari.",
    "Broadcaster.AudioAndVideoSelection.NoDevicesError": "We hebben geen geluid en/of video bronnen kunnen vinden. Dit kan komen omdat deze bronnen geen toegang hebben om gebruikt te mogen worden in je browser. <br> Het kan ook voorkomen dat de geluidsbron of videobron (microfoon / webcam) al ingebruik is (op een ander tabblad in je browser).",
    "Broadcaster.Button.ClaimActivePresenter": "Overnemen als presentator",
    "Broadcaster.Button.DesktopShare": "Desktop delen",
    "Broadcaster.Button.End": "Einde uitzending",
    "Broadcaster.Button.Pause": "Pauze",
    "Broadcaster.Button.Resume": "Hervatten!",
    "Broadcaster.Button.Start": "Go live!",
    "Broadcaster.Button.ExtendDuration": "Verleng duur met {{minutes}} minuten",
    "Broadcaster.Button.NextSlideToggle.Max": "Voorvertoning slide maximaliseren",
    "Broadcaster.Button.NextSlideToggle.Min": "Voorvertoning slide minimaliseren",
    "Broadcaster.Button.SwitchFullSize.ToSlides": "Wissel naar volledige slides grootte",
    "Broadcaster.Button.SwitchFullSize.ToVideo": "Wissel naar volledige video grootte",

    "Broadcaster.Dialog.ConnectionIssue.Button.Close": "Sluiten en terugkeren naar de uitzending",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.Text": "Er komt geen beeld meer binnen van uw encoder, of de verbinding met de server is weggevallen. <strong>Wij pauzeren het webinar hierdoor niet:</strong> kijkers zien en horen weer wat uw encoder verstuurt zodra die opnieuw verbindt.<br>Controleer uw encoder en uw internetverbinding.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.WaitingForMedia": "De verbinding met de server is in orde, maar er komt geen beeld binnen van uw encoder. Controleer of uw encoder nog uitzendt.",

    "Broadcaster.Dialog.ConnectionIssue.Encoder.TextResume": "Zodra uw encoder weer uitzendt, kunt u dit venster sluiten en verdergaan.",
    "Broadcaster.Dialog.ConnectionIssue.Reconnecting": "Er wordt geprobeerd opnieuw verbinding te maken met de server.",
    "Broadcaster.Dialog.ConnectionIssue.WaitingForMedia": "De verbinding met de server is in orde. We wachten tot uw beeld en geluid weer doorkomen; daarna kunt u hervatten.",
    "Broadcaster.Dialog.ConnectionIssue.SuggestRefresh": "Vernieuw de pagina om de uitzending opnieuw te laden.",
    "Broadcaster.Dialog.ConnectionIssue.Text": "De verbinding met de server is verbroken vanwege een probleem met uw internetverbinding. <strong>Het webinar is gepauzeerd.</strong><br>Controleer uw verbinding en/of sluit andere tabbladen in uw browser.",
    "Broadcaster.Dialog.ConnectionIssue.TextResume": "Als de verbinding hersteld is, kunt u op de onderstaande knop Hervatten klikken om de uitzending voort te zetten.",
    "Broadcaster.Dialog.ConnectionIssue.Title": "Verbinding verbroken",
    "Broadcaster.Dialog.EncoderPause.Title": "Pauzeren bij een externe encoder",
    "Broadcaster.Dialog.EncoderPause.Text": "Deze uitzending komt uit je eigen encoder, dus wij kunnen de inkomende video niet pauzeren. Je kijkers blijven ontvangen wat je encoder verstuurt, ongeacht de stand van dit webinar. Zet het beeld en geluid in je eigen encoder uit als je niet gezien of gehoord wilt worden.",
    "Broadcaster.Dialog.MoqFallback.Title": "Overgeschakeld naar de klassieke verbinding",
    "Broadcaster.Dialog.MoqFallback.Text": "Media over QUIC kon geen verbinding maken. We maken nu verbinding via de klassieke verbinding (WebRTC). Was je al live, hervat het webinar dan zodra je beeld terug is.",
    "Broadcaster.Moq.SlowConnect.Text": "Verbinden via Media over QUIC duurt langer dan verwacht…",
    "Broadcaster.Moq.SlowConnect.Button": "Nu overschakelen naar de klassieke verbinding (WebRTC)",
    "Broadcaster.Dialog.EndWebinar.Button.Confirm": "Ja, beëindig uitzending",
    "Broadcaster.Dialog.EndWebinar.Text": "Weet u zeker dat u deze uitzending wilt beëindigen?",
    "Broadcaster.Dialog.EndWebinar.Title": "Uitzending beëindigen",
    "Broadcaster.Dialog.TooEarly.Title": "Oeps, je bent iets te vroeg!",
    "Broadcaster.Dialog.TooEarly.Text": "Wij hebben gemerkt dat je jouw webinar iets eerder wilt starten dan de geplande starttijd. Weet je zeker dat je dit wilt doen?",
    "Broadcaster.Dialog.TooEarly.CountdownText": "Aftellen naar geplande starttijd:",
    "Broadcaster.Dialog.TooEarly.OnlineViewersTitle": "Aantal kijkers al online:",
    "Broadcaster.Dialog.TooEarly.OnlineViewersText": "online",

    "Broadcaster.Message.Ended": "Dit webinar is geëindigd <span>op</span> {{date}} <span>om</span> {{time}}",
    "Broadcaster.Poll.Button.Start": "Poll starten",
    "Broadcaster.Poll.Button.Close": "Poll sluiten",
    "Broadcaster.Poll.Button.HideResults": "Uitslag verbergen",
    "Broadcaster.Poll.NoPublicResults": "De resultaten van deze poll worden niet openbaar getoond.",
    "Broadcaster.Poll.WeightingApplied": "Wegingsfactor toegepast",
    "Broadcaster.RemainingTimePanel.Ending": "Het webinar wordt beëindigd over",
    "Broadcaster.RemainingTimePanel.ExtensionFailed": "De eindtijd van het webinar kon niet worden verlengd",
    "Broadcaster.RemainingTimePanel.ExtensionNotAvailable": "De eindtijd van het webinar kan niet meer worden verlengd",
    "Broadcaster.RemainingTimePanel.ExtensionSuccess": "De eindtijd van het webinar is succesvol verlengd",

    "Broadcaster.Status.Broadcasting": "Live",
    "Broadcaster.Status.GoLiveIn": "Ga live in",
    "Broadcaster.Status.GoLiveNow": "Ga nu live",
    "Broadcaster.Status.Ended": "Beëindigd",
    "Broadcaster.Status.Camera": "Camera is geselecteerd",
    "Broadcaster.Status.Camera.Issue": "Geen geschikte camera geselecteerd",
    "Broadcaster.Status.Heading": "Status",
    "Broadcaster.Status.Mic": "Microfoon is geselecteerd",
    "Broadcaster.Status.Mic.Issue": "Geen microfoon geselecteerd",
    "Broadcaster.Status.PossibleSolution": "Mogelijke oplossing:",
    "Broadcaster.Status.Recorder.Issue": "Uw webinar wordt niet opgenomen",
    "Broadcaster.Status.Recorder": "Uw webinar wordt opgenomen",
    "Broadcaster.Status.Encoder": "Uw encoder-instellingen kloppen",
    "Broadcaster.Status.Encoder.Issue.Audio": "Uw encoder stuurt surround-geluid",
    "Broadcaster.Status.Encoder.Issue.Level": "Uw encoder gebruikt een video-instelling die sommige apparaten weigeren",
    "Broadcaster.Status.Encoder.Issue.Unknown": "We konden uw encoder nog niet controleren",
    "Broadcaster.Status.Solution.Encoder.Audio": "Zet uw encoder op stereo (2 kanalen) en verbind opnieuw. Tot die tijd horen kijkers met Firefox niets en kunt u niet live gaan.",
    "Broadcaster.Status.Solution.Encoder.Level": "Zet het H.264-niveau in uw encoder op 4.2, of op automatisch, en verbind opnieuw. Tot die tijd weigeren sommige iPhones, iPads en televisies de stream en kunt u niet live gaan.",
    "Broadcaster.Status.Encoder.Issue.AudioAndLevel": "Uw encoder heeft twee instellingen die aangepast moeten worden",
    "Broadcaster.Status.Solution.Encoder.AudioAndLevel": "Zet uw encoder op stereo (2 kanalen) en zet het H.264-niveau op 4.2, of op automatisch. Verbind daarna opnieuw. Tot die tijd horen kijkers met Firefox niets, weigeren sommige iPhones, iPads en televisies de stream, en kunt u niet live gaan.",
    "Broadcaster.Status.Solution.Encoder.Unknown": "Heeft u uw encoder net verbonden, wacht dan een paar seconden. Blijft deze melding staan, controleer dan of uw encoder uitzendt.",
    "Broadcaster.Status.Server": "Verbonden met de server",
    "Broadcaster.Status.Server.Issue": "Geen verbinding met de server",
    "Broadcaster.Status.Solution.Initializing": "De verbinding wordt geïnitialiseerd, een ogenblik geduld alsjeblieft",
    "Broadcaster.Status.Solution.Refresh": "Vernieuw uw browser",
    "Broadcaster.Status.Solution.WaitForTimeslot": "Wacht tot jouw tijdslot beschikbaar wordt",
    "Broadcaster.Status.Solution.Button.Reconnect": "Klik hier om opnieuw verbinding te maken",
    "Broadcaster.Status.Troubleshoot.Button": "Problemen oplossen",
    "Broadcaster.Status.Troubleshoot.Text": "Als de problemen aanhouden, klik dan op de onderstaande knop om naar een pagina voor probleemoplossingen te gaan met de meest voorkomende problemen en oplossingen:",
    "Broadcaster.Status.VideoServer": "Verbonden met de videoserver",
    "Broadcaster.Status.VideoServer.Issue": "Geen verbinding met de videoserver",
    "Broadcaster.Status.VideoServer.Optimal": "Optimale verbinding met de videoserver",
    "Broadcaster.Status.VideoServer.Score": "Huidige verbindingsscore:",
    "Broadcaster.Status.VideoServer.Score.Audio": "Audio score is <strong>{{audioScore}}</strong> van <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Video": "Video score is <strong>{{videoScore}}</strong> van <strong>10</strong>",
    "Broadcaster.Status.VideoServer.Score.Text": "Het kan zijn dat uw internetverbinding of computer niet snel genoeg is om een ​​webinar uit te zenden. Als u een draadloze verbinding gebruikt, probeer dan over te schakelen naar een bekabelde verbinding.",
    "Broadcaster.Status.VideoServer.Unstable": "De verbinding met de videoserver is instabiel",
    "Broadcaster.Status.ServerActions.Issue": "De server ondervindt problemen bij het verwerken van sommige van uw acties",

    "Chat.Button.ChatPaused.FollowChat": "Bekijk laatste bericht",
    "Chat.Button.ChatPaused.Paused": "Chat gepauzeerd vanwege scrollen",
    "Chat.ChannelName.All": "Alle deelnemers",
    "Chat.ChannelName.Public": "Publiek",
    "Chat.ChannelName.Moderator": "Moderatoren",
    "Chat.ChannelName.Presenter": "Presentator",
    "Chat.ChannelName.Speakers": "Sprekers",
    "Chat.ChannelName.Unknown": "Onbekend",
    "Chat.Channel.Button.Close": "Sluit privé kanaal met {{channelName}}",
    "Chat.Channel.Button.CloseAndMarkUnread": "Sluit privé kanaal met {{channelName}}, en markeer berichten als ongelezen",
    "Chat.Message.Button.CancelForward": "Annuleer doorsturen bericht",
    "Chat.Message.Deleted": "Dit bericht is verwijderd",
    "Chat.Message.ForwardedFrom": "Doorgestuurd van ",
    "Chat.Message.ReplyingTo": "Reageren op ",
    "Chat.MessageInput.CharactersRemaining": "{{characterAmount}} letters over",
    "Chat.OnDemand.InfoText": "Uw chat berichten worden doorgestuurd. Binnen 48 uur ontvangt u van ons een reactie.",
    "Chat.Option.Delete": "Verwijder bericht",
    "Chat.Option.ForwardToPresenter": "Doorsturen naar de presentator chat",
    "Chat.Option.ForwardToModerator": "Doorsturen naar moderator chat",
    "Chat.Option.ForwardToPublic": "Doorsturen naar publieke chat",
    "Chat.Option.OriginalForwardToModerator": "Stuur origineel bericht door naar moderator chat",
    "Chat.Option.OriginalForwardToPresenter": "Stuur origineel bericht door naar presentator chat",
    "Chat.Option.OriginalForwardToPublic": "Stuur origineel bericht door naar publieke chat",
    "Chat.Option.ReplyPrivately": "Privé beantwoorden",
    "Chat.OnDemandChat.Nickname": "Systeembericht",
    "Chat.OnDemandChat.Message": "Uw chat berichten zijn doorgestuurd naar de presentator.",

    "ChatSettings.OnDemandChat.Label.Email": "Doorsturen naar e-mailadres",
    "ChatSettings.OnDemandChat.Switch.Label": "On demand chat inschakelen",
    "ChatSettings.PageHeading": "Chat instellingen",

    "Chat.Standard.Header": "Standaard berichten",
    "Chat.Standard.Message1": "",
    "Chat.Standard.Message2": "",
    "Chat.Standard.Message3": "",
    "Chat.Standard.Message4": "",
    "Chat.Standard.Message5": "",
    "Chat.Standard.Message6": "",
    "Chat.Standard.Message7": "",
    "Chat.Standard.Message8": "",
    "Chat.Standard.Message9": "",
    "Chat.Standard.NoMessages": "Er zijn nog geen standaardberichten gedefinieerd.",

    "CompositePageHeader.Label.Date": "datum:",
    "CompositePageHeader.Label.Event": "webinar:",

    "ContactList.Button.Export": "Exporteer lijst",
    "ContactList.Table.Header.Date": "Datum",
    "ContactList.Table.Header.FirstOnline": "Eerste keer online",
    "ContactList.Table.Header.TimeOnline": "Tijd online",
    "ContactList.Table.Header.PercentageOnline": "%",

    "Content.Attachments.Button.Delete": "Verwijder bijlage {{file}}",
    "Content.Attachments.Button.Edit": "Bewerk bijlage {{file}}",
    "Content.Attachments.Dialog.Heading": "Bijlage bewerken",
    "Content.Attachments.Dialog.Label.AttachmentTitle": "Naam van de bijlage",
    "Content.Attachments.Dialog.Label.AttachmentVisibility": "Zichtbaarheid van de bijlage",
    "Content.Attachments.DragDrop.AcceptedFileTypes": "PDF",
    "Content.Attachments.Heading.MultipleAttachments": "{{amount}} bijlagen",
    "Content.Attachments.Heading.OneAttachment": "1 bijlage",
    "Content.Attachments.PageHeading": "Bijlagen",
    "Content.Attachments.Progress.Label": "Document uploaden:",
    "Content.Attachments.Table.Header.Visibility": "Zichtbaarheid",
    "Content.Attachments.Table.Header.Title": "Naam",
    "Content.Attachments.Table.Header.Type": "Type",
    "Content.Attachments.Type.File": "Bestand",
    "Content.Attachments.Visibility.Authenticated": "Geverifieerd",
    "Content.Attachments.Visibility.Private": "Privé",
    "Content.Attachments.Visibility.Public": "Publiek",

    "Content.Chapters.Button.AddChapter": "Toevoegen hoofdstuk",
    "Content.Chapters.Button.DeleteChapter": "Verwijder hoofdstuk {{chapter}}",
    "Content.Chapters.ChapterTitleHeader": "Titel van het hoofdstuk",
    "Content.Chapters.ConfirmDelete.Title": "Delete chapter",
    "Content.Chapters.ConfirmDelete.Msg": "Weet je zeker dat je hoofdstuk <strong>{{chapter}}</strong> wenst te verwijderen?",
    "Content.Chapters.PageHeading": "Hoofdstukken",
    "Content.Chapters.SlideNumberHeader": "Begint met slide",
    "Content.Chapters.ReadOnly": "Dit webinar is al uitgezonden. Hoofdstukken kunnen worden gewijzigd in de on-demand editor.",

    "Content.Overview.Button.Edit": "Bewerken",
    "Content.Overview.Button.Share": "Delen",
    "Content.Overview.Button.Broadcast": "Broadcast",
    "Content.Overview.Button.Publish": "Publiceren",
    "Content.Overview.Button.Unpublish": "Publicatie ongedaan maken",
    "Content.Overview.Exam.Active": "Examen aan",
    "Content.Overview.Exam.Inactive": "Examen uit",
    "Content.Overview.Exam.NotValid": "Examen niet geldig",
    "Content.Overview.Images.Info": "De profielfoto moet minimaal een grootte hebben van 120 x 120 pixels. De bannerfoto moet minimaal een grootte hebben van 896 x 224 pixels. Je kunt afbeeldingen met verschillende aspectverhoudingen gebruiken; ze worden bijgesneden rond het midden.",
    "Content.Overview.Images.Label": "Webinar profiel en banner afbeelding",
    "Content.Overview.Security.Active": "Beveiliging aan",
    "Content.Overview.Security.Inactive": "Beveiliging uit",
    "Content.Overview.Survey.Active": "Enquête aan",
    "Content.Overview.Survey.Inactive": "Enquête uit",
    "Content.Overview.Survey.NotValid": "Enquête niet geldig",

    "Content.Poll.AddPoll": "Poll toevoegen",
    "Content.Poll.AnswerHeader": "Antwoorden",
    "Content.Poll.PointsHeader": "Punten (optioneel)",
    "Content.Poll.Button.DeletePollAnswer": "Verwijder poll antwoord",
    "Content.Poll.Button.DeletePoll": "Verwijder poll",
    "Content.Poll.Button.DeletePollAriaLabel": "Verwijder poll {{poll}}",
    "Content.Poll.ConfirmDelete.Title": "Verwijder poll",
    "Content.Poll.ConfirmDelete.Msg": "Weet je zeker dat je <strong>{{poll}}</strong> wenst te verwijderen?",
    "Content.Poll.Link.WeightinFactor": "Wegingsfactor lijst",
    "Content.Poll.Option.ApplyWeighting": "Wegingsfactor toepassen op deze poll vraag",
    "Content.Poll.Option.PublicResults": "Toon de uitslag van de poll aan de kijkers",
    "Content.Poll.Option.ShowPercentagesOnly": "Toon alleen percentages in de uitslag van de poll",
    "Content.Poll.Option.ShowPercentagesOnly.DisabledReason": "Alleen van toepassing als de uitslag van de poll aan de kijkers wordt getoond",
    "Content.Poll.PageHeading": "Polls",
    "Content.Poll.PollItemHeader": "Welke vraag wil je je doelgroep stellen?",
    "Content.Poll.QuestionLabel": "Je vraag",
    "Content.Poll.OptionLabel": "Antwoord {{index}}{{char}}",
    "Content.Poll.OptionPlaceholder": "Antwoord",
    "Content.Poll.PointsLabel": "Punten voor antwoord {{index}}{{char}} (optioneel)",
    "Content.Poll.PointsPlaceholder": "Punten",
    "Content.Poll.UpdateOnlyWarning": "Dit webinar is al uitgezonden. Alleen de wegingsfactor en punten kunnen worden aangepast.",

    "Content.PollWeighting.Button.ClearList": "Wis lijst",
    "Content.PollWeighting.DragDrop.AcceptedFileTypes": ".xls, .xlsx en .csv",
    "Content.PollWeighting.Input.DefaultWeight": "Standaard wegingsfactor",
    "Content.PollWeighting.Heading.DefaultWeight": "Standaard wegingsfactor",
    "Content.PollWeighting.Text.DefaultWeight": "De standaard wegingsfactor wordt toegepast op alle deelnemers die niet in de wegingsfactor lijst staan. Zet de standaard wegingsfactor op 0 als je geen wegingsfactor wilt toepassen op de deelnemers die niet in de wegingsfactor lijst staan.",
    "Content.PollWeighting.Heading.ImportList": "Lijst importeren",
    "Content.PollWeighting.Text.ImportList": "Importeer een Excel-document met twee kolommen: één voor het e-mailadres en één voor de gewichtsfactor (aantal). Deze gewichtsfactor wordt vervolgens gebruikt voor het berekenen van de resultaten van de poll. <strong>Het Excel-document mag geen titels of kopteksten bevatten.</strong>",
    "Content.PollWeighting.NoWeights": "Er zijn geen wegingsfactoren toegepast op deze poll.",
    "Content.PollWeighting.Heading.List": "Gewichtsfactor lijst",
    "Content.PollWeighting.PageHeading": "Poll weging",
    "Content.PollWeighting.Table.Heading.Email": "E-mailadres",
    "Content.PollWeighting.Table.Heading.Factor": "Wegingsfactor",
    "Content.PollWeighting.Table.Button.DeleteEntry": "Verwijder {{email}} uit de gewichtsfactor lijst",

    "Content.Slides.ConfirmDelete.Title": "Slides verwijderen",
    "Content.Slides.ConfirmDelete.Msg": "Weet je zeker dat je de huidige slides wilt verwijderen?",
    "Content.Slides.FileLabel": "Bestand",
    "Content.Slides.PageHeading": "Slides",
    "Content.Slides.PreviewHeading": "Preview",
    "Content.Slides.SlidesAmountLabel": "Aantal slides",
    "Content.Slides.Status.Error": "Je slides worden verwerkt",
    "Content.Slides.Status.Processing": "Je slides worden verwerkt",
    "Content.Slides.Status.Queued": "Je slides staan in de rij om verwerkt te worden",
    "Content.Slides.Status.Success": "Bestand succesvol geüpload",
    "Content.Slides.Restrictions": "<bold>PDF</bold>",
    "Content.Slides.ReadOnly": "Dit webinar is al uitgezonden. Slides kunnen worden gewijzigd in de on-demand editor.",

    "Dashboard.Heading.Upcoming": "Aankomende webinars",
    "Dashboard.Heading.UpNext": "Volgende",
    "Dashboard.Link.AllEvents": "Bekijk alle webinars",
    "Dashboard.PageHeading": "Dashboard",

    "DefaultSurvey.Title": "Enquête",
    "DefaultSurvey.Intro": "Wilt u alstublieft de enquête invullen?",
    "DefaultSurvey.Outro": "Dank u voor het invullen van de enquête.",
    "DefaultSurvey.Question.OverallRating": "Wat is uw algemene waardering over dit webinar op een schaal van 1 (zeer slecht) tot 10 (uitmuntend)?",
    "DefaultSurvey.Question.SpeakerRating": "Wat is uw oordeel over de spreker(s) op een schaal van 1 (zeer slecht) tot 10 (uitmuntend)?",
    "DefaultSurvey.Question.ContentRating": "Wat vond u van de inhoud van het webinar op een schaal van 1 (zeer slecht) tot 10 (uitmuntend)?",
    "DefaultSurvey.Question.QuestionRating": "Indien u een vraag had, zijn deze naar behoren beantwoord?",
    "DefaultSurvey.Question.WouldRecommend": "Zou u in de toekomst vaker willen deelnemen aan een webinar?",
    "DefaultSurvey.Question.OpenQuestion": "Heeft u nog vragen of opmerkingen, dan kunt u deze hier vermelden.",
    "DefaultSurvey.Answer.Yes": "Ja",
    "DefaultSurvey.Answer.No": "Nee",
    "DefaultSurvey.Answer.Other": "Anders",

    "EditExam.Info.ZeroMeansUnlimitedRetries": "Voer het aantal keren in dat de deelnemer het examen mag herkansen. Als 0 (nul) wordt ingevuld, betekent dit dat het examen oneindig vaak kan worden herkanst.",
    "EditExam.Heading.Failed": "Examen niet gehaald tekst",
    "EditExam.Heading.Intro": "Introductie tekst",
    "EditExam.Heading.Outro": "Bedankt tekst",
    "EditExam.Heading.Passed": "Examen gehaald tekst",
    "EditExam.Heading.Questions": "Questions",
    "EditExam.Heading.Settings": "Instellingen",
    "EditExam.Label.AllowRetries": "De deelnemer toestaan ​​het examen opnieuw af te leggen",
    "EditExam.Label.Enable": "Enable exam",
    "EditExam.Label.Failed": "Examen niet gehaald tekst",
    "EditExam.Label.Intro": "Introductie tekst",
    "EditExam.Label.MaximumRetries": "Het aantal herkansingen",
    "EditExam.Label.Outro": "Bedankt tekst",
    "EditExam.Label.Passed": "Examen gehaald tekst",
    "EditExam.Label.PassingScore": "De score om het examen te halen",
    "EditExam.Label.Required": "Het examen is verplicht",
    "EditExam.Label.ShowResult": "Toon de uitslag van het examen aan de deelnemer",
    "EditExam.Label.ShowWrongAnswers": "Toon aan welke vragen de deelnemer fout heeft beantwoord",
    "EditExam.Label.Title": "Titel van het examen",
    "EditExam.NoQuestions": "Het examen bevat geen vragen",
    "EditExam.Pageheading": "Examen",
    "EditExam.Save.Saved": "Opgeslagen",
    "EditExam.Save.Saving": "Opslaan van je wijzigingen",
    "EditExam.Save.Error": "Fout bij het opslaan van het examen",
    "EditExam.Tab.Failed": "Niet gehaald",
    "EditExam.Tab.Intro": "Intro",
    "EditExam.Tab.Outro": "Outro",
    "EditExam.Tab.Passed": "Geslaagd",
    "EditExam.Tab.Questions": "Vragen",
    "EditExam.Tab.Settings": "Instellingen",
    "EditExam.Validation.FailedRequired": "'Examen niet gehaald' tekst is verplicht",
    "EditExam.Validation.IntroRequired": "Introductie tekst is verplicht",
    "EditExam.Validation.OutroRequired": "Bedankt tekst is verplicht",
    "EditExam.Validation.PassedRequired": "'Examen geslaagd' tekst is verplicht",
    "EditExam.Validation.QuestionsRequired": "Vragen zijn verplicht",
    "EditExam.Validation.TitleRequired": "Een titel voor het examen is verplicht",

    "EditFollowUp.Heading.EmailTemplate": "Sjabloon voor follow-up e-mail",
    "EditFollowUp.Label.BccOwner": "Voeg de organisator toe als BCC",
    "EditFollowUp.Label.MinimumExamAnswers": "Minimum aantal beantwoorde examenvragen",
    "EditFollowUp.Label.MinimumExamPoints": "Minimum aantal examenpunten",
    "EditFollowUp.Label.MinimumOnlinePercentage": "Minimumpercentage bekeken",
    "EditFollowUp.Label.MinimumPollPoints": "Minimum aantal poll-punten",
    "EditFollowUp.Label.MinimumPollVotes": "Minimum aantal poll-stemmen",
    "EditFollowUp.Label.MinimumSurveyAnswers": "Minimum aantal enquêteantwoorden",
    "EditFollowUp.Label.Name": "Naam",
    "EditFollowUp.PageHeading": "Follow-up e-mail bewerken",
    "EditFollowUp.Toast.Error": "Er is een fout opgetreden. De follow-up is niet opgeslagen.",
    "EditFollowUp.Toast.Saved": "Follow-up opgeslagen",
    "EditFollowUp.Toast.Saving": "Follow-up opslaan",

    "EditQuestionnaire.Button.AddMultipleChoiceQuestion": "Multiple choice vraag",
    "EditQuestionnaire.Button.AddSingleChoiceQuestion": "Single choice vraag",
    "EditQuestionnaire.Button.AddOpenQuestion": "Open vraag",
    "EditQuestionnaire.Button.AddOption": "Voeg een antwoord toe",
    "EditQuestionnaire.Button.DeleteQuestion": "Vraag verwijderen",
    "EditQuestionnaire.Button.EditQuestion": "Vraag bewerken",
    "EditQuestionnaire.Button.MoveDown": "Verplaats antwoord naar beneden",
    "EditQuestionnaire.Button.MoveUp": "Verplaats antwoord naar boven",
    "EditQuestionnaire.Button.QuestionSortDown": "Verplaats vraag naar beneden",
    "EditQuestionnaire.Button.QuestionSortUp": "Verplaats vraag naar boven",
    "EditQuestionnaire.Button.RemoveOption": "Verwijder dit antwoord",
    "EditQuestionnaire.Heading.MultipleChoiceQuestion": "Multiple choice vraag",
    "EditQuestionnaire.Heading.Options": "Antwoorden",
    "EditQuestionnaire.Heading.OpenQuestion": "Open vraag",
    "EditQuestionnaire.Heading.SingleChoiceQuestion": "Single choice vraag",
    "EditQuestionnaire.Label.HasOtherOption": "Inclusief 'andere' optie",
    "EditQuestionnaire.Label.Option": "Antwoord {{number}}",
    "EditQuestionnaire.Label.OptionValue": "Waarde",
    "EditQuestionnaire.Label.OtherOptionText": "'Andere' optie tekst",
    "EditQuestionnaire.Label.Question": "Vraag",
    "EditQuestionnaire.Label.RequiredQuestion": "Deze vraag is verplicht",
    "EditQuestionnaire.QuestionDetail.Options": "Antwoorden:",
    "EditQuestionnaire.QuestionDetail.OtherOptionText": ", inclusief andere optie",
    "EditQuestionnaire.QuestionDetail.Question": "Vraag:",
    "EditQuestionnaire.QuestionDetail.Required": "Verplicht:",
    "EditQuestionnaire.Validation.OptionTextRequired": "Er ontbreekt tekst bij antwoord {{option}} van vraagnummer {{question}}",
    "EditQuestionnaire.Validation.OptionValueRequired": "Antwoord {{option}} van vraagnummer {{question}} heeft geen geldige waarde",
    "EditQuestionnaire.Validation.OptionsRequired": "Ontbrekende antwoorden bij vraagnummer {{question}}",
    "EditQuestionnaire.Validation.OtherOptionTextRequired": "Ontbrekende optietekst 'anders' bij vraagnummer {{question}}",
    "EditQuestionnaire.Validation.QuestionRequired": "Ontbrekende vraag bij vraagnummer {{question}}",

    "EditSubtitles.Button.Delete": "Verwijder ondertitels {{name}}",
    "EditSubtitles.Button.Download": "Download ondertitels {{name}}",
    "EditSubtitles.Button.GenerateSubtitles": "Ondertitels genereren",
    "EditSubtitles.Button.GeneratorSubtitles": "Start ondertitelgenerator",
    "EditSubtitles.DragDrop.AcceptedFileTypes": ".srt and .vtt",
    "EditSubtitles.GenerateSubtitlesOptions.DeepgramSettings": "Deepgram instellingen",
    "EditSubtitles.GenerateSubtitlesOptions.Title": "Ondertitels genereren",
    "EditSubtitles.GeneratorSubtitles.InfoText": "Als uw on-demand webinar geen ondertitels heeft, kunt u deze automatisch genereren. Mochten er tijdens het live webinar al ondertitels zijn gegenereerd, dan is het wellicht verstandig om deze opnieuw te genereren, omdat de vertaling dan nauwkeuriger zal zijn.",
    "EditSubtitles.GeneratorStatus.Generating": "Ondertitels worden gegenereerd",
    "EditSubtitles.PageHeading": "Ondertitels bewerken",
    "EditSubtitles.TableHeader.Default": "Standaard",
    "EditSubtitles.TableHeader.Enabled": "Ingeschakeld",
    "EditSubtitles.TableHeader.TrackId": "Track-ID",

    "EditSurvey.Heading.Intro": "Introductie tekst",
    "EditSurvey.Heading.Outro": "Bedankt tekst",
    "EditSurvey.Heading.Questions": "Vragen",
    "EditSurvey.Label.Enabled": "Enquête aanzetten",
    "EditSurvey.Label.Intro": "Introductie tekst",
    "EditSurvey.Label.Outro": "Bedankt tekst",
    "EditSurvey.Label.Required": "De enquête is verplicht",
    "EditSurvey.Label.Title": "Titel van de enquête",
    "EditSurvey.NoQuestions": "De enquête bevat geen vragen",
    "EditSurvey.Pageheading": "Enquête",
    "EditSurvey.Save.Saved": "Opgeslagen",
    "EditSurvey.Save.Saving": "Opslaan van je wijzigingen",
    "EditSurvey.Save.Error": "Fout bij het opslaan van de enquête",
    "EditSurvey.Tab.Intro": "Intro",
    "EditSurvey.Tab.Outro": "Outro",
    "EditSurvey.Tab.Questions": "Vragen",
    "EditSurvey.Validation.IntroRequired": "Introductie tekst is verplicht",
    "EditSurvey.Validation.OutroRequired": "Bedankt tekst is verplicht",
    "EditSurvey.Validation.QuestionsRequired": "Vragen zijn verplicht",
    "EditSurvey.Validation.TitleRequired": "Titel is verplicht",

    "Editor.Button.Save": "Opslaan",
    "Editor.Button.SaveOndemand": "On demand opslaan",
    "Editor.Button.MoveToIndicator": "Plaats bij indicator",
    "Editor.Chapter.Button.Add": "Voeg nieuw hoofdstuk toe",
    "Editor.Chapter.Button.Delete": "Verwijder chapter",
    "Editor.Chapter.Heading": "Hoofdstuk bewerken",
    "Editor.Chapter.New": "Hoofdstuk",
    "Editor.Chapter.Title.Label": "Hoofdstuk titel",
    "Editor.Chat.Button.Add": "Voeg nieuw chat bericht toe",
    "Editor.Chat.Button.Delete": "Verwijder chat bericht",
    "Editor.Chat.Message.Label": "Chat bericht tekst",
    "Editor.Chat.Heading": "Chat bericht bewerken",
    "Editor.Download.Video.Button": "Download MP4 video",
    "Editor.Download.Video.Heading": "Download orginele video",
    "Editor.Download.Video.Text": "U kunt de originele video downloaden als MP4-bestand. Bijgesneden video die met de editor zijn gemaakt, zijn niet op deze video toegepast.",
    "Editor.PageHeading": "Editor",
    "Editor.Publishing.Modal.Close": "Sluit dit bericht",
    "Editor.Publishing.Modal.Error": "Er is een fout opgetreden bij het opslaan van uw wijzigingen.",
    "Editor.Publishing.Modal.Success": "Uw wijzigingen zijn succesvol opgeslagen!",
    "Editor.Publishing.Modal.Progress.Label": "Publicatievoortgang:",
    "Editor.Publishing.Modal.Publishing": "Wijzigingen publiceren",
    "Editor.Publishing.Modal.PublishingHeader": "Wijzigingen publiceren",
    "Editor.Publishing.Modal.PublishingDescription": "Nadat de wijzigingen zijn opgeslagen, zijn ze zichtbaar in de on-demand.",
    "Editor.Publishing.Modal.KeyframeExtraction": "Extracting",
    "Editor.Publishing.Modal.KeyframeExtractionHeader": "Extracting keyframes",
    "Editor.Publishing.Modal.KeyframeExtractionDescription": "Keyframes are being extracted from the video. This may take a while depending on the length of the video.",
    "Editor.Publishing.Modal.Encoding": "Reencoding",
    "Editor.Publishing.Modal.EncodingHeader": "Reencoding video",
    "Editor.Publishing.Modal.EncodingDescription": "The video is being reencoded with the applied changes. This may take a while depending on the length of the video.",
    "Editor.Publishing.Modal.GetDurationStep": "Getting video duration",
    "Editor.Publishing.Modal.EncodeStep": "Reencoding video",
    "Editor.Publishing.Modal.CreateHlsStep": "Creating HLS video",
    "Editor.Publishing.Modal.KeyframeExtractionStep": "Extracting keyframes",
    "Editor.Publishing.Modal.CleanupStep": "Cleaning up",
    "Editor.Poll.Button.Delete": "Verwijder poll",
    "Editor.Poll.Button.Next": "Volgende poll",
    "Editor.Poll.Button.Previous": "Vorige poll",
    "Editor.Poll.Heading": "Poll bewerken",
    "Editor.SaveInfoText": "Wijzigingen die in de editor zijn gedaan, zijn zichtbaar in de on demand nadat u op 'On demand opslaan' hebt geklikt.",
    "Editor.Slides.Button.Add": "Voeg nieuwe slide toe",
    "Editor.Slides.Button.Delete": "Verwijder slide",
    "Editor.Slides.Button.Replace": "Vervang slide",
    "Editor.Slides.Heading": "Slide bewerken",
    "Editor.Timeline.Zoom.Text": "Tijdlijn zoom:",
    "Editor.Timestamp.Legend": "Starttijd",
    "Editor.Trackname.Chapters": "Hoofdstukken",
    "Editor.Trackname.Chat": "Chat",
    "Editor.Trackname.Polls": "Polls",
    "Editor.Trackname.Slides": "Slides",
    "Editor.Trackname.VideoLayout": "Video lay-out",
    "Editor.TrimVideo.Button.Delete": "Verwijder bijsnijden video",
    "Editor.TrimVideo.Heading": "Video bijsnijden",
    "Editor.TrimVideo.TrimNumber": "Trim {{number}}",
    "Editor.Upload.Button": "Video uploaden",
    "Editor.Upload.Button.Cancel": "Upload annuleren",
    "Editor.Upload.Button.Pause": "Upload pauzeren",
    "Editor.Upload.Button.Resume": "Upload hervatten",
    "Editor.Upload.DragDrop.AcceptedFileTypes": ".3g2, .3gp, .avi, .flv, .h264, .mkv, .mov, .mp4, .mpeg, .mpg, .qt, .webm en .wmv",
    "Editor.Upload.Heading": "Video uploaden",
    "Editor.Upload.Paused": "Het uploaden van de video is gepauzeerd.",
    "Editor.Upload.Progress.Label": "Video aan het uploaden",
    "Editor.VideoBeingAnalyzed": "Even geduld, de video wordt geanalyseerd",
    "Editor.VideoLayout.Heading": "Video layout bewerken",
    "Editor.VideoLayout.Item.Classic": "Klassiek",
    "Editor.VideoLayout.Item.Default": "Standaard",
    "Editor.VideoLayout.Item.DesktopSharing": "Desktop delen",
    "Editor.VideoLayout.Item.PresentationWithVideoLarge": "Video met kleine slides",
    "Editor.VideoLayout.Item.PresentationWithVideoSmall": "Slides met kleine video",
    "Editor.VideoLayout.Item.UnknownLayout": "Onbekende video layout",
    "Editor.VideoLayout.Item.VideoOnly": "Alleen video",

    "Email.Preview.Heading": "Preview",
    "Email.Preview.Updating": "Preview bijwerken",
    "Email.Style.Error.InvalidStyle": "Ongeldige stijl",
    "Email.Style.HeaderImage.AcceptedTypes": "JPG, PNG, GIF en WebP",
    "Email.Style.HeaderImage.AltTextInfo": "Beschrijf de afbeelding als die informatie bevat, zoals een logo met tekst. Laat leeg bij een puur decoratieve afbeelding.",
    "Email.Style.HeaderImage.Button.UseDefault": "Standaardafbeelding gebruiken",
    "Email.Style.HeaderImage.CurrentImageAlt": "Huidige headerafbeelding van de e-mail",
    "Email.Style.HeaderImage.FileLimits": "Maximaal 10 MB. Van een geanimeerde GIF blijft alleen het eerste beeld over.",
    "Email.Style.HeaderImage.Heading": "Headerafbeelding",
    "Email.Style.HeaderImage.Info": "De afbeelding wordt rond het midden bijgesneden tot 580 × 160 pixels en opgeslagen als JPG of PNG, wat het kleinst is. Een nieuwe afbeelding geldt alleen voor e-mails die vanaf nu worden verstuurd.",
    "Email.Style.HeaderImage.Label.AltText": "Alternatieve tekst voor de headerafbeelding",
    "Email.Style.HeaderImage.Warning.NoPlaceholder": "De sjabloon hieronder bevat geen @HeaderImageUrl, dus de headerafbeelding verschijnt niet in de e-mails. Gebruik src=\"@HeaderImageUrl\" alt=\"@HeaderImageAlt\" op de headerafbeelding.",
    "Email.Style.HeaderImage.Warning.TooSmall": "Deze afbeelding is kleiner dan 580 × 160 pixels. Ze wordt vergroot en kan wazig worden.",
    "Email.Style.Label.Button": "Button stijl",
    "Email.Style.Label.Code": "Code stijl",
    "Email.Style.Label.Heading": "Koptekst {{level}} stijl",
    "Email.Style.Label.Paragraph": "Paragraaf stijl",
    "Email.Style.Label.Template": "Sjabloon",
    "Email.Style.PageHeading": "E-mail template stijl",
    "Email.Style.Warning": "Let op: de sjabloon en de stijlen worden opgeschoond om XSS-aanvallen te voorkomen. Controleer na het opslaan of de stijlen nog steeds correct zijn.",
    "Email.Template.Label.Body": "Body",
    "Email.Template.Label.IncludeCalendarAttachment": "Kalenderbestand meesturen (.ics)",
    "Email.Template.Label.SelectTemplate": "Selecteer e-mail template",
    "Email.Template.Label.Subject": "Onderwerp",
    "Email.Template.PageHeading": "E-mail template",

    "EmailStatus.Failed": "Mislukt",
    "EmailStatus.Queued": "In de wachtrij",
    "EmailStatus.Sending": "Verzenden",
    "EmailStatus.Sent": "Verzonden",

    "FollowUpOverview.Button.CreateFollowUp": "Follow-up aanmaken",
    "FollowUpOverview.Button.Delete": "Verwijder follow-up {{name}}",
    "FollowUpOverview.Button.Edit": "Bewerk follow-up {{name}}",
    "FollowUpOverview.InfoText": "Hier kunt u een of meerdere follow-up e-mails definiëren. Een follow-up e-mail wordt verzonden wanneer aan bepaalde voorwaarden is voldaan. Bijvoorbeeld wanneer een deelnemer het hele webinar heeft bekeken of geslaagd is voor een examen.",
    "FollowUpOverview.NoFollowUps": "Er is geen follow-up e-mail actief voor dit webinar.",
    "FollowUpOverview.PageHeading": "Follow-up e-mail",
    "FollowUpOverview.TableHeader.BccOwner": "BCC organisator",
    "FollowUpOverview.TableHeader.Name": "Naam",
    "FollowUpOverview.TableHeader.Processed": "Verzonden",

    "Footer.Link.CookiePolicy": "Cookie Policy",
    "Footer.Link.PrivacyPolicy": "Privacy Policy",
    "Footer.Link.Support": "Support",
    "Footer.Link.TermsOfUse": "Terms and Conditions",

    "Generic.ApiErrorCode.Exception": "Er is iets verkeerd gegaan",
    "Generic.ApiErrorCode.Exception.Body": "Er is iets misgegaan, vernieuw de pagina of probeer het later opnieuw.",
    "Generic.ApiErrorCode.NotFoundException": "Niet gevonden",
    "Generic.ApiErrorCode.NotFoundException.Body": "De pagina die je zoekt, bestaat niet meer.",
    "Generic.ApiErrorCode.NotPublishedException": "Niet gepubliceerd",
    "Generic.ApiErrorCode.NotPublishedException.Body": "Het webinar dat u zoekt is momenteel niet gepubliceerd.",
    "Generic.ApiErrorCode.CancelledException": "Geannuleerd",
    "Generic.ApiErrorCode.CancelledException.Body": "Het webinar dat u zoekt is geannuleerd.",
    "Generic.ApiErrorCode.ExpiredException": "Verlopen",
    "Generic.ApiErrorCode.ExpiredException.Body": "Het webinar dat u zoekt is verlopen.",
    "Generic.ApiErrorCode.AccessDeniedException": "Geen toegang",
    "Generic.ApiErrorCode.AccessDeniedException.Body": "Je hebt geen toegang tot deze pagina.",
    "Generic.ApiErrorCode.AccountNotVerifiedException": "Account is niet geverifieerd",
    "Generic.ApiErrorCode.AccountNotVerifiedException.Body": "Deze functionaliteit is alleen beschikbaar voor geverifieerde accounts.",
    "Generic.ApiErrorCode.ServiceUnavailableException": "Tijdelijk niet beschikbaar",
    "Generic.ApiErrorCode.ServiceUnavailableException.Body": "Er wordt onderhoud uitgevoerd aan het platform. Probeer het over enkele minuten opnieuw.",

    "Generic.Button.AriaLabel.isLoading": "Verwerken",
    "Generic.Loading": "Bezig met laden",
    "Generic.Button.Back": "Ga terug",
    "Generic.Button.Cancel": "Annuleren",
    "Generic.Button.Continue": "Doorgaan",
    "Generic.Button.Delete": "Verwijder",
    "Generic.Button.Details": "Details",
    "Generic.Button.Export": "Exporteer",
    "Generic.Button.Save": "Opslaan",
    "Generic.Button.SaveChanges": "Wijzigingen opslaan",
    "Generic.Button.TryAgain": "Probeer opnieuw",
    "Generic.Button.UploadImage": "Afbeelding uploaden",
    "Generic.Button.Watch": "Bekijken",

    "Generic.Dialog.Button.Close": "Sluiten",
    "Generic.DragDrop": "Drag & Drop",
    "Generic.DragDrop.AcceptedImageTypes": "JPG, PNG en WEBP",
    "Generic.DragDrop.AcceptedText": "De volgende bestandsformaten worden ondersteund: ",
    "Generic.DragDrop.Active": "Zet de bestanden hier neer...",
    "Generic.DragDrop.BrowseFiles": "of <span>blader</span> door uw bestanden",
    "Generic.FileRejection.FileInvalidType": "Dit bestandstype wordt hier niet ondersteund.",
    "Generic.FileRejection.FileTooLarge": "Dit bestand is te groot.",
    "Generic.FileRejection.FileTooSmall": "Dit bestand is te klein.",
    "Generic.FileRejection.TooManyFiles": "Je kunt hier maar één bestand tegelijk toevoegen.",
    "Generic.FileRejection.Unknown": "Dit bestand kan hier niet worden gebruikt.",
    "Generic.Link.Context": ": {{title}}",
    "Generic.Link.Logo": "{{site}} - {{page}}",
    "Generic.Link.OpensInNewTab": "(opent in een nieuw tabblad)",
    "Generic.Link.ViewDetails": "Bekijk details",
    "Generic.Link.WebinarSchedule": "Webinaroverzicht",
    "Generic.And": "en",
    "Generic.Days": "dagen",
    "Generic.Hour": "uren",
    "Generic.Hour.Full": "Uren",
    "Generic.Minute": "min",
    "Generic.Minute.Full": "Minuten",
    "Generic.Second": "sec",
    "Generic.Second.Full": "Seconden",
    "Generic.Interested": "Geïnteresseerd",
    "Generic.NotInterested": "Niet geïnteresseerd",
    "Generic.Skiplink": "Doorspoelen naar het hoofd onderdeel ",

    "Image.AltText": "Alt-tekst",
    "Image.AltText.Explanation": "Beschrijf wat de afbeelding laat zien of betekent, zoals de tekst erin. Laat dit leeg als de afbeelding alleen decoratief is. Maximaal 250 tekens.",
    "ImportInvites.Button.Import": "Importeer deelnemers",
    "ImportInvites.Dialog.Progress": "{{current}} van {{total}} importeren",
    "ImportInvites.Dialog.Title": "Deelnemers importeren",
    "ImportInvites.DragDrop.AcceptedFileTypes": ".xls, .xlsx, .csv, .ods, .fods en .txt",
    "ImportInvites.ErrorMessage.WorkBookError": "Er moeten minimaal een e-mailadres worden geïmporteerd",
    "ImportInvites.Label.HasHeader": "Document heeft een header",
    "ImportInvites.Label.Worksheet": "Kies een werkblad",
    "ImportInvites.MapOption.NotImported": "Niet geïmporteerd",
    "ImportInvites.PageHeading": "Deelnemers importeren",
    "ImportInvites.Text.HasHeader": "Als uw document kopteksten bevat, selecteer dan de onderstaande optie:",
    "ImportInvites.Text.NoDataRows": "Er zijn geen gegevensrijen in dit bestand gevonden. Als uw bestand geen koprij heeft, schakel dan \"Document heeft een header\" hierboven uit.",
    "ImportInvites.Text.MapColumns": "Selecteer voor elke kolom in de tabel een ​​eigenschap uit de lijst, zodat wij de gegevens correct kunnen importeren.",
    "ImportInvites.Text.MultipleWorksheets": "Uw document bevat meerdere werkbladen. Selecteer welk werkblad u wilt importeren:",

    "Insights.Chat.AmountText": "Aantal chatberichten:",
    "Insights.Chat.Button.Export": "Exporteer chatberichten",
    "Insights.Chat.PageHeading": "Chat berichten",
    "Insights.Exam.AmountText": "Aantal gestelde examen vragen:",
    "Insights.Exam.PageHeading": "Examen resultaten",
    "Insights.Exam.Button.Export": "Exporteer examenresultaten",
    "Insights.Exam.Label.Result": "Resultaat",
    "Insights.Exam.Label.Score": "Score",
    "Insights.Exam.Result.Failed": "Niet gehaald",
    "Insights.Exam.Result.Passed": "Geslaagd",
    "Insights.Exam.Select.Combined": "Gecombineerde examenresultaten",
    "Insights.Exam.Select.Label": "Toon examenresultaten",
    "Insights.Exam.Select.Live": "Live examenresultaten",
    "Insights.Exam.Select.OnDemand": "On demand examenresultaten",
    "Insights.Exam.Tab.ParticipantDetails": "Gegevens deelnemers",
    "Insights.Exam.Tab.AnswersOverview": "Overzicht van de antwoorden",
    "Insights.Interested.PageHeading": "Geïnteresseerde accounts",
    "Insights.Live.AmountText.Single": "deelnemer heeft live gekeken",
    "Insights.Live.AmountText.Multiple": "deelnemers hebben live gekeken",
    "Insights.Live.PageHeading": "Live deelnemers",
    "Insights.OnDemand.AmountText.Single": "deelnemer heeft on demand gekeken",
    "Insights.OnDemand.AmountText.Multiple": "deelnemers hebben on demand gekeken",
    "Insights.OnDemand.PageHeading": "On demand deelnemers",
    "Insights.Polls.AmountText": "Aantal gestelde pollvragen:",
    "Insights.Polls.Button.Export": "Exporteer poll resultaten",
    "Insights.Polls.PageHeading": "Poll resultaten",
    "Insights.Polls.Select.Combined": "Gecombineerde poll resultaten",
    "Insights.Polls.Select.Label": "Toon poll resultaten",
    "Insights.Polls.Select.Live": "Live poll resultaten",
    "Insights.Polls.Select.OnDemand": "On demand poll resultaten",
    "Insights.Survey.AmountText": "Aantal gestelde enquêtevragen:",
    "Insights.Survey.PageHeading": "Resultaten van de enquête",
    "Insights.Survey.Button.Export": "Exporteer resultaten",
    "Insights.Survey.Select.Combined": "Gecombineerde enquête resultaten",
    "Insights.Survey.Select.Label": "Toon enquête resultaten",
    "Insights.Survey.Select.Live": "Live enquête resultaten",
    "Insights.Survey.Select.OnDemand": "On demand enquête resultaten",

    "Invites.Button.DeleteParticipant": "Verwijder {{email}} uit de geïmporteerde deelnemers",
    "Invites.Button.EmailPending": "E-mail openstaande uitnodigingen",
    "Invites.Button.EmailReminder": "E-mail herinneringen",
    "Invites.Button.Import": "Deelnemers importeren",
    "Invites.Button.ResendAllInvites": "Alle uitnodigingen opnieuw sturen",
    "Invites.Button.ResendAllReminders": "Alle herinneringen opnieuw sturen",
    "Invites.Settings.AutoSendInvite": "Uitnodiging automatisch verzenden na import",
    "Invites.Settings.AutoSendReminder": "Herinnering automatisch verzenden",
    "Invites.Settings.ReminderHoursBeforeWebinar": "Uur voor het webinar",
    "Invites.Button.ResetInvite": "Verzend uitnodiging opnieuw naar {{email}}",
    "Invites.Dialog.Emailing.Progress": "Verzenden {{current}} van {{total}}",
    "Invites.Dialog.Emailing.Title": "E-mails verzenden",
    "Invites.Heading.ImportedParticipants": "Imported participants",
    "Invites.PageHeading": "Deelnemers uitnodigen",

    "Campaign.New": "Nieuwe campagne",
    "Campaign.NewName": "Nieuwe campagne",
    "Campaign.Table.Name": "Naam",
    "Campaign.Table.Created": "Aangemaakt",
    "Campaign.Table.Status": "Status",
    "Campaign.Table.Sent": "Verzonden",
    "Campaign.Table.InterestedNow": "Nu geïnteresseerd",
    "Campaign.Status.Draft": "Concept",
    "Campaign.Status.Sent": "Verzonden",
    "Campaign.Field.Name": "Naam van de campagne",
    "Campaign.Field.Name.Edit": "Campagnenaam bewerken",
    "Campaign.Tab.Audience": "Doelgroep",
    "Campaign.Tab.Addresses": "Adressen",
    "Campaign.Tab.EmailTemplate": "E-mailsjabloon",
    "Campaign.Lists.Heading": "Doelgroep",
    "Campaign.Lists.Webinar": "Webinarlijsten",
    "Campaign.Lists.Global": "Globale lijsten",
    "Campaign.Lists.CreateWebinarList": "Een nieuwe lijst voor dit webinar importeren",
    "Campaign.Lists.SelectExistingList": "Bestaande lijst selecteren",
    "Campaign.Lists.AddSelected": "Geselecteerde toevoegen",
    "Campaign.Lists.NoGlobalLists": "Geen globale lijsten beschikbaar om toe te voegen.",
    "Campaign.Lists.RemoveGlobalList": "Lijst {{name}} verwijderen",
    "Campaign.Lists.DeleteWebinarList": "Lijst {{name}} verwijderen",
    "Campaign.Send": "Versturen",
    "Campaign.Warning.NotPublished": "Versturen is niet mogelijk omdat het webinar nog niet is gepubliceerd.",

    "Campaign.CannotSend.Header": "Deze campagne kan nog niet verstuurd worden:",
    "Campaign.CannotSend.IncompleteSubject": "Voer een onderwerp in voor de e-mailsjabloon",
    "Campaign.CannotSend.IncompleteBody": "Vul de inhoud van de e-mailsjabloon in",
    "Campaign.CannotSend.NoLists": "Selecteer minimaal één lijst",
    "Campaign.CannotSend.NotPublished": "Het webinar is niet gepubliceerd",
    "Campaign.Delete": "Campagne verwijderen",
    "Campaign.SendConfirm.Title": "Deze campagne versturen?",
    "Campaign.SendConfirm.Body": "De e-mail wordt naar de geselecteerde lijsten verstuurd. Na het versturen kan de campagne niet meer worden bewerkt.",
    "Campaign.DeleteConfirm.Title": "Deze campagne verwijderen?",
    "Campaign.DeleteConfirm.Body": "Hiermee verwijdert u de campagne definitief. Deze actie kan niet ongedaan worden gemaakt.",
    "Campaign.Detail.SentAt": "Verstuurd op",
    "Campaign.Detail.NotSent": "Nog niet verstuurd",
    "Campaign.Detail.RecipientCount": "Ontvangers",
    "Campaign.Detail.EstimatedRecipients": "Ontvangers (geschat)",
    "Campaign.Detail.Sent": "Verzonden",
    "Campaign.Detail.Failed": "Mislukt",
    "Campaign.Detail.Blacklisted": "Op blacklist",
    "Campaign.Detail.AlreadyInterested": "Al geïnteresseerd",
    "Campaign.Detail.AlreadySentInAnotherList": "Overgeslagen (andere lijst)",
    "Campaign.Detail.InterestedNow": "Nu geïnteresseerd",
    "Campaign.Detail.RecipientsHeading": "Ontvangers",
    "Campaign.AddLists.Heading": "Naar meer lijsten versturen",
    "Campaign.AddLists.Intro": "Voeg meer lijsten toe om nieuwe mensen te bereiken. Iedereen die al in deze campagne zit, wordt automatisch overgeslagen.",
    "Campaign.AddLists.Button": "Toevoegen en versturen",
    "Campaign.AddLists.NoSelectionHint": "Selecteer minimaal één lijst om naar te versturen.",
    "Campaign.AddLists.None": "Al uw lijsten voor dit webinar zitten al in deze campagne.",
    "Campaign.Recipients.Search": "Zoeken",
    "Campaign.Recipients.StatusFilter": "Filteren op status",
    "Campaign.Recipients.AllStatuses": "Alle statussen",
    "Campaign.Recipients.Email": "E-mailadres",
    "Campaign.Recipients.Name": "Naam",
    "Campaign.Recipients.Company": "Bedrijf",
    "Campaign.Recipients.List": "Lijst",
    "Campaign.Recipients.SentAt": "Verstuurd op",
    "Campaign.Recipients.Status": "Status",
    "Campaign.Recipients.Empty": "Geen ontvangers gevonden.",
    "Campaign.RecipientStatus.Pending": "In behandeling",
    "Campaign.RecipientStatus.Sent": "Verzonden",
    "Campaign.RecipientStatus.Failed": "Mislukt",
    "Campaign.RecipientStatus.Blacklisted": "Op blacklist",
    "Campaign.RecipientStatus.AlreadyInterested": "Al geïnteresseerd",
    "Campaign.RecipientStatus.AlreadySentInAnotherList": "Overgeslagen (andere lijst)",
    "Campaign.SelectList.Heading": "Selecteer een lijst",
    "Campaign.SelectList.Back": "Terug naar lijsten",
    "Campaign.SelectList.UseList": "Gebruik deze lijst",
    "Campaign.SelectList.Empty": "Geen lijsten beschikbaar.",

    "Generic.Pagination.Previous": "Vorige",
    "Generic.Pagination.Next": "Volgende",
    "Generic.Pagination.PageOf": "Pagina {{page}} van {{total}}",

    "Invites.Table.Header.InvitedAt": "Uitgenodigd op",
    "Invites.Table.Header.Status": "Uitnodiging",
    "Invites.Table.Header.ReminderStatus": "Herinnering",

    "LiveTranscribe.Label.DeepgramLanguage": "De gesproken taal in dit webinar",
    "LiveTranscribe.Label.DeepgramDefault": "Gebruik Deepgram als standaard transcriptietool",
    "LiveTranscribe.Label.DeepgramEnabled": "Live transcriptie inschakelen met Deepgram",
    "LiveTranscribe.Label.DeepgramModel": "Deepgram model",
    "LiveTranscribe.Label.SmartFormat": "Schakel Smart Format in. SmartFormat kan transcripten automatisch opmaken om de leesbaarheid te verbeteren.",
    "LiveTranscribe.Label.TrackId": "Track-ID",
    "LiveTranscribe.Option.DeepgramLanguage.Dutch": "Nederlands",
    "LiveTranscribe.Option.DeepgramLanguage.English": "Engels",
    "LiveTranscribe.Option.DeepgramLanguage.French": "Frans",
    "LiveTranscribe.Option.DeepgramLanguage.German": "Duits",
    "LiveTranscribe.Option.DeepgramLanguage.Multi": "Meerdere talen",
    "LiveTranscribe.PageHeading": "Live transcriptie",
    "LiveTranscribe.SectionHeader.DeepgramSettings": "Deepgram-instellingen",

    "MainMenu.Content": "Webinar inhoud",
    "MainMenu.CreateNew": "Maak een nieuw webinar aan",
    "MainMenu.Label": "Hoofdmenu",
    "MainMenu.ManageEnv": "Beheer omgeving",
    "MainMenu.Overview": "Georganiseerde webinars",
    "MainMenu.Share": "Delen",
    "MainMenu.Schedule": "Webinaroverzicht",
    "MainMenu.Support": "Help",
    "MainMenu.Toggle.Close": "Menu sluiten",
    "MainMenu.Toggle.Open": "Menu openen",

    "Manage.Link.AccountInvites": "Deelnemers uitnodigen",
    "Manage.Link.EmailStyle": "Beheer e-mail template style",
    "Manage.Link.EmailTemplates": "Beheer e-mail templates",
    "Manage.Link.ManagePrepend": "Beheer",
    "Manage.Link.Translation": "Beheer teksten",
    "Manage.Link.WebinarDuration": "Bekijk de instellingen",
    "Manage.PageHeading": "Beheer omgeving",

    "Marketing.PageHeading": "Marketing",

    "Menu.Dropdown.Options": "Opties",

    "OptionMenu.Content": "Bewerken",
    "OptionMenu.EditOnDemand": "On demand bewerken",
    "OptionMenu.Insights": "Insights",
    "OptionMenu.Marketing": "Marketing",
    "OptionMenu.Pay": "Betaal nu",
    "OptionMenu.Security": "Beveiliging",
    "OptionMenu.Share": "Delen",
    "OptionMenu.ShareOnDemand": "Deel de opname",
    "OptionMenu.SlideController": "Slide controller",
    "OptionMenu.Test": "Test verbinding",
    "OptionMenu.WatchOnDemand": "Bekijk de opname",

    "Pages.404.Header": "Oops",
    "Pages.404.Text": "Deze pagina bestaat niet. Ga terug naar het webinar overzicht of ga terug naar de vorige pagina.",
    "Pages.404.SideContent.Header": "Waarom?",
    "Pages.404.SideContent.Text": "Dit hoort helemaal niet zo te gaan!!",
    "Pages.Auth.SideContent.Header": "Beste relatie,",
    "Pages.Auth.SideContent.Text": "Welkom bij het online videoplatform. Hier kunt u livestreams online bijwonen en terugkijken indien er een terugkijkmogelijkheid is. We benadrukken dat de livestreams vertrouwelijk zijn en dat deze niet met derden mogen worden gedeeld.",
    "Pages.ForgotPassword.Header": "Wachtwoord vergeten",
    "Pages.Login.Header": "Log in of maak een account aan",
    "Pages.Organized.Header": "Georganiseerde webinars",
    "Pages.Organized.Heading.OnDemand": "On demand webinars",
    "Pages.Organized.Heading.Upcoming": "Aankomende webinars",
    "Pages.Organized.NoEnded.Title": "Beëindigde webinars",
    "Pages.Organized.NoEnded.Text": "Hier worden de beëindigde webinars getoond.",
    "Pages.Organized.NoUpcoming.Title": "Hier is niets te zien",
    "Pages.Organized.NoUpcoming.Text": "Webinars die je hebt georganiseerd, zullen hier verschijnen. Waarom probeer je het nu niet??",
    "Pages.Organized.NoUpcoming.Button": "Creëer je eigen webinar",
    "Pages.Organized.TabEnded": "Afgelopen webinars",
    "Pages.Organized.TabOnDemand": "On demand webinars",
    "Pages.Organized.TabUpcoming": "Aankomende webinars",
    "Pages.Organized.TabSearch": "Zoekresultaten",
    "Pages.Organized.NotFound.Title": "Geen resultaten gevonden",
    "Pages.Organized.NotFound.Text": "Geen webinars komen overeen met je zoekopdracht. Probeer een ander trefwoord.",
    "Pages.Organized.Heading.Found": "Zoekresultaten",
    "Pages.Register.Header": "Registreren",
    "Pages.Register.Webinar.CreateAccount": "Om dit webinar te kunnen bekijken, moet u inloggen met een account of een nieuw account aanmaken:",
    "Pages.Register.Webinar.Interested": "U bent geïnteresseerd in het volgende webinar:",
    "Pages.Register.WebinarModerator": "U bent uitgenodigd om het volgende webinar te modereren:",
    "Pages.Register.WebinarModerator.CreateAccount": "Om dit webinar te kunnen modereren, moet u inloggen met een account of een nieuw account aanmaken.",
    "Pages.Register.WebinarBroadcaster": "U bent uitgenodigd om het volgende webinar uit te zenden:",
    "Pages.Register.WebinarBroadcaster.CreateAccount": "Om dit webinar te kunnen uitzenden, moet u inloggen met een account of een nieuw account aanmaken:",

    "Participants.Online": "Online:",
    "Participants.Search.Label": "Filter",

    "Player.Button.Fullscreen": "Volledig scherm",
    "Player.Button.ExitFullscreen": "Verlaat volledig scherm",
    "Player.Button.Poll": "Poll",
    "Player.Button.Subtitles": "Ondertiteling",
    "Player.Chapters.Add": "Je kunt hoofdstukken toevoegen",
    "Player.Chapters.Heading": "Hoofdstukken",
    "Player.NoChapters": "Er zijn nog geen hoofdstukken te zien",
    "Player.Chat.ForwardedFrom": "Bericht doorgestuurd van ",
    "Player.Chat.Global": "Publiek",
    "Player.Chat.Header": "Chat",
    "Player.Chat.Nickname.Required": "Vul een nickname in om te kunnen chatten.",
    "Player.Chat.Nickname.Placeholder": "Uw nickname",
    "Player.Chat.Nickname.UpdateButton": "Nickname opslaan",
    "Player.Chat.InputPlaceHolder": "Heb je een vraag of opmerking? Typ hier je bericht.",
    "Player.Chat.Live.Ended": "Het webinar is afgelopen en alle moderators zijn nu offline, er is geen chat meer mogelijk.",
    "Player.Chat.OnDemand": "Je kunt je bericht hier verzenden, het wordt doorgestuurd naar de organisator van dit webinar.",
    "Player.Chat.Private": "Support",
    "Player.Chat.Send": "Bericht versturen",
    "Player.Info.State.CountDownWithTime": "Het webinar start over:",
    "Player.Info.State.WebinarStarting": "Een ogenblik geduld alstublieft, het webinar wordt binnen enkele momenten hervat.",
    "Player.Menu.Chapters": "Hoofdstuk",
    "Player.Menu.Chat": "Chat",
    "Player.Menu.NewSlide": "nieuwe slide",
    "Player.Menu.Slides": "Slides",
    "Player.Menu.UnreadMessages_one": "{{count}} ongelezen bericht",
    "Player.Menu.UnreadMessages_other": "{{count}} ongelezen berichten",
    "Player.Menu.Video": "Video",
    "Player.NoPolls": "Er zijn nog geen polls om te tonen",
    "Player.Poll.ResultsAtEndMessage": "Dank voor het stemmen.",
    "Player.SubtitleSelect.NoSubtitles": "Ondertiteling uit",
    "Player.ThanksForWatching.Button.Replay": "Opnieuw afspelen",
    "Player.ThanksForWatching.Heading": "Thank you for watching!",
    "Player.ThanksForWatching.Link.Url": "/",
    "Player.ThanksForWatching.Link.Overview": "Webinaroverzicht",
    "Player.Resume.Loading": "Bezig met laden…",
    "Player.Resume.Notice": "We gaan verder waar je gebleven was",
    "Player.Recovery.Reconnecting": "Opnieuw verbinden…",
    "Player.Recovery.Failed": "De video kon niet worden hersteld.",
    "Player.Recovery.TryAgain": "Opnieuw proberen",
    "Player.UserInputButton.Audio": "Aanzetten audio",
    "Player.UserInputButton.Play": "Afspelen",

    "poll.viewIconLabel": "icoon-poll",

    "presentationSlide.NoSlide": "Geen slides om te tonen",
    "presentationSlide.Upload": "Ajb uploaden",

    "ProcessedFollowUp.Button.Export": "Lijst exporteren",
    "ProcessedFollowUp.Heading.SentTo": "Follow-up verzonden naar",
    "ProcessedFollowUp.PageHeading": "Verzonden follow-up",
    "ProcessedFollowUp.TableHeader.CreatedAt": "Verzonden op",
    "ProcessedFollowUp.TableHeader.EmailStatus": "Status",
    "ProcessedFollowUp.TableHeader.ExamAnswers": "Toets antwoorden",
    "ProcessedFollowUp.TableHeader.ExamPoints": "Toets punten",
    "ProcessedFollowUp.TableHeader.Name": "Naam",
    "ProcessedFollowUp.TableHeader.OnlinePercentage": "Percentage bekeken",
    "ProcessedFollowUp.TableHeader.PollPoints": "Poll punten",
    "ProcessedFollowUp.TableHeader.PollVotes": "Poll antwoorden",
    "ProcessedFollowUp.TableHeader.SurveyAnswers": "Enquête antwoorden",

    "Questionnaire.Accreditation": "Accreditatie wordt verzorgd door:",
    "Questionnaire.Button.End": "Sluiten",
    "Questionnaire.Button.Next": "Volgende",
    "Questionnaire.Button.Previous": "Terug",
    "Questionnaire.Button.Retry": "Opnieuw proberen",
    "Questionnaire.Button.StartExam": "Examen afleggen",
    "Questionnaire.Exam.WrongAnswers": "U heeft de volgende vragen fout beantwoord:",
    "Questionnaire.OpenQuestion.Placeholder": "Je antwoord",
    "Questionnaire.OtherAnswer.Placeholder": "Vul je antwoord in",
    "Questionnaire.Preface": "Voorwoord",
    "Questionnaire.Progress": "Vraag {{number}} van {{total}}",
    "Questionnaire.Question.Required": "Deze vraag is verplicht",
    "Questionnaire.Result": "Resultaat",
    "Questionnaire.ResultLoading": "Uw resultaat bepalen",
    "Questionnaire.Retakes": "Aantal beschikbare herkansingen: <strong>{{retakes}}</strong>.",
    "Questionnaire.WrongAnswers": "Je hebt de volgende <strong>{{amount}}</strong> examen vragen fout beantwoord:",

    "ResetPassword.PageHeading": "Wachtwoord opnieuw instellen",

    "resumeConfirmationMessage.withTimer": "Het webinar is gepauzeerd en wordt hervat in:",

    "Schedule.LoginToSeeWebinars": "Sommige webinars zijn mogelijk niet zichtbaar. <a>Log in</a> voor een compleet overzicht van alle webinars.",
    "Schedule.NoPublicWebinars.Text": "Op dit moment zijn er geen openbare webinars beschikbaar. Kom later nog eens terug of log in om de volledige lijst met webinars te bekijken.",
    "Schedule.NoWebinars.Title": "Hier is nog niets te zien!",
    "Schedule.NoWebinars.Text": "Webinars waarin je hebt aangegeven geïnteresseerd te zijn, zullen hier verschijnen.",
    "Schedule.PageHeading": "Webinaroverzicht",
    "Schedule.ShowMoreOndemand": "Toon alle on demand webinars",
    "Schedule.ShowMoreUpcoming": "Toon alle aankomende webinars",
    "Schedule.Switch.ShowInterested": "Toon alleen webinars waarvoor ik me heb geregistreerd.",
    "Schedule.UpNext": "Volgende",

    "Search.Button.Clear.AriaLabel": "Wis selectie",
    "Search.Placeholder": "Zoek naar een webinar",

    "Security.AllowAnonymousWarning": "Door anonieme kijkers toe te staan, kan iedereen met de link naar uw webinar deze bekijken, zelfs als ze niet zijn ingelogd. Dit omzeilt dus alle beveiligingsmaatregelen. Deel de link naar uw webinar alleen met mensen die u vertrouwt. Als extra beveiligingsmaatregel kunt u een autorisatiecode instellen die een speciale webinarlink genereert voor anonieme kijkers.",
    "Security.AnonymousViewerAuthorizationCodeLabel": "Autorisatiecode voor anonieme kijkers",
    "Security.AnonymousViewerLinkLabel": "Anonieme kijker link:",
    "Security.Button.GenerateCode": "Genereer code",
    "Security.Introtext": "Op deze pagina kunt u accounts wel of niet toestaan ​​dit webinar te bekijken. Dit kunt u doen door één of meerdere e-mailadressen in te vullen. Ook is het mogelijk om e-mailadressen in of uit te sluiten van een domein, door @domeinnaam in te voeren (bijvoorbeeld @onlinewebinar.com).",
    "Security.InfoText.Important": "Belangrijk!",
    "Security.InfoText.Item1": "Niet toestaan ​​heeft voorrang op toestaan. Dit betekent dat als je een heel domein niet toestaat, het onmogelijk is om één account met een e-mailadres uit dat domein toe te staan.<br /> Andersom werkt het ook: je kunt accounts met e-mailadressen uit een bepaald domein toestaan. Als u een e-mailadres van dit domein niet toestaat, kan dit account nog steeds dit webinar niet bekijken.",
    "Security.InfoText.Item2": "Als u accounts niet toestaat, kunnen ze alleen uw webinar niet bekijken. Zij kunnen nog steeds de detailpagina van uw webinar zien.",
    "Security.Filter.Allow": "Toestaan filter",
    "Security.Filter.Disallow": "Niet toestaan filter",
    "Security.Filter.Button.Save": "Filter opslaan",
    "Security.FilterResults.Heading": "Filter resultaat",
    "Security.FilterResults.Label.TestResults": "Test e-mailadres",
    "Security.FilterResults.Table.Header.Email": "E-mailadres",
    "Security.PageHeading": "Webinar Beveiliging",
    "Security.Switch.OneViewerSession": "Sta slechts één kijkersessie per deelnemer toe",
    "Security.Switch.RequireVerified": "Geverifieerde accounts zijn vereist",
    "Security.Switch.AllowAnonymous": "Sta anonieme kijkers toe",

    "Share.Button.CopyLink": "Kopieer link",
    "Share.CopiedLink": "Link kopiëren gelukt",
    "Share.InviteBroadcaster.Heading": "Nodig een broadcaster uit via een link",
    "Share.InviteBroadcaster.Text": "U kunt een of meerdere presentatoren uitnodigen voor uw webinar door deze link te delen:",
    "Share.InviteBroadcaster.WarningText": "Belangrijk! Deel deze link alleen met mensen die u vertrouwt.",
    "Share.InviteModerator.Heading": "Nodig een moderator uit via een link",
    "Share.InviteModerator.Text": "U kunt één of meerdere moderatoren uitnodigen voor uw webinar door deze link te delen:",
    "Share.InviteModerator.WarningText": "Belangrijk! Deel deze link alleen met mensen die u vertrouwt.",
    "Share.InviteParticipants.AnonymousEnabled.WarningText": "Belangrijk! Deel deze link alleen met mensen die u vertrouwt. Anonieme kijkers zijn ingeschakeld, wat betekent dat iedereen met de link naar uw webinar deze kan bekijken, zelfs als ze niet zijn ingelogd. Dit omzeilt dus alle beveiligingsmaatregelen.",
    "Share.InviteParticipants.Heading": "Nodig deelnemers uit via een link",
    "Share.InviteParticipants.Text": "U kunt anderen uitnodigen om zich aan te melden voor uw webinar en deze te bekijken door deze link te delen:",
    "Share.InviteSpeaker.Heading": "Nodig een spreker uit via een link",
    "Share.InviteSpeaker.Text": "U kunt een of meerdere sprekers uitnodigen voor uw webinar door deze link te delen:",
    "Share.PageHeading": "Deel uw webinar",
    "Share.SignUps": "Aanmeldingen",
    "Share.InviteAnonymous.Heading": "Nodig anonieme kijkers uit via een link",
    "Share.InviteAnonymous.Text": "Je kunt anonieme kijkers uitnodigen voor je webinar door deze link te delen:",
    "Share.InviteAnonymous.WarningText": "Belangrijk! Deel deze link alleen met mensen die u vertrouwt. Door anonieme kijkers toe te staan, kan iedereen met de link naar uw webinar deze bekijken, zelfs als ze niet zijn ingelogd. Dit omzeilt alle beveiligingsmaatregelen.",

    "Speaker.List.Heading": "Sprekers ({{count}})",
    "Speaker.List.Button.Notify": "Waarschuw {{name}}",
    "Speaker.List.Button.Kick": "Verwijder {{name}} uit het webinar",
    "Speaker.Status.Offline": "Offline",
    "Speaker.Status.SettingUp": "Instellen",
    "Speaker.Status.AwaitingAdmission": "Wacht op toelating",
    "Speaker.Status.Connecting": "Verbinden",
    "Speaker.Status.NotReady": "Niet klaar",
    "Speaker.Status.Ready": "Klaar",
    "Speaker.Status.GoingLive": "Gaat live",
    "Speaker.Status.OnAir": "Live",
    "Speaker.Status.Error": "Fout",
    "Speaker.Status.Banned": "Verbannen",

    "Speaker.WaitingRoom.Heading": "Wachtruimte voor sprekers",
    "Speaker.WaitingRoom.Kicked": "U bent door de uitzender uit het webinar verwijderd.",
    "Speaker.WaitingRoom.Notified": "De uitzender vraagt uw aandacht.",
    "Speaker.WaitingRoom.Status.Live": "Het webinar is live.",
    "Speaker.WaitingRoom.Status.WaitingReady": "U bent klaar — wachten tot de uitzender u erbij haalt.",
    "Speaker.WaitingRoom.Status.WaitingNotReady": "Zet \"Klaar\" aan zodra u de uitzender wilt laten weten dat u klaar bent.",
    "Speaker.WaitingRoom.ReadyToggle.Label": "Ik ben klaar om op te treden",

    "Slide.Button.Current": "Ga naar huidige slide",
    "Slide.Button.First": "Ga naar de eerste slide",
    "Slide.Button.Next": "Volgende slide",
    "Slide.Button.Previous": "Vorige slide",

    "Status.Message.Interrupted": "De uitzending is onderbroken. Even geduld aub.",
    "Status.Message.NotStarted": "De uitzending is nog niet begonnen. Even geduld aub.",
    "Status.Message.Paused": "De uitzending is gepauzeerd. Even geduld aub.",

    "TestSuite.Button.RetryTest": "Doe de test opnieuw",
    "TestSuite.Button.StartTest": "Start de test",
    "TestSuite.BroadcastConnection.Error": "Er is een fout opgetreden bij het verbinden van de broadcast video. Vernieuw de pagina.",
    "TestSuite.BroadcastConnection.UnstableNetwork": "De netwerkverbinding is instabiel. Controleer uw internetverbinding.",
    "TestSuite.BroadcastConnection.VeryUnstableNetwork": "De netwerkverbinding is erg instabiel. Controleer uw internetverbinding.",
    "TestSuite.BroadcastScore.Audio": "Audio score:",
    "TestSuite.BroadcastScore.Video": "Video score:",
    "TestSuite.BroadcastState.Broadcasting": "Uitzenden",
    "TestSuite.BroadcastState.Initializing": "Initialiseren",
    "TestSuite.BroadcastState.NotBroadcasting": "Niet aan het uitzenden",
    "TestSuite.Connection.Connected": "Verbonden",
    "TestSuite.Connection.Connecting": "Verbinding maken",
    "TestSuite.Connection.Disconnected": "Niet verbonden",
    "TestSuite.Connection.Label": "Verbinding:",
    "TestSuite.Line.Advice": "Laat de test minstens vijf minuten lopen: veel lijnproblemen treden maar af en toe op.",
    "TestSuite.Line.ApiErrorCode.LineProbeDisabled": "De lijntest is niet beschikbaar op dit platform.",
    "TestSuite.Line.ApiErrorCode.ThrottledException": "Te veel tests gestart, probeer het later opnieuw.",
    "TestSuite.Line.BackToChoice": "Terug naar de testkeuze",
    "TestSuite.Line.Button.Retry": "Opnieuw proberen",
    "TestSuite.Line.Button.Start": "Start de meting",
    "TestSuite.Line.Button.Stop": "Stop de meting",
    "TestSuite.Line.Chart.Jitter.Aria": "Jitter per seconde, laatste mediaan {{p50}}.",
    "TestSuite.Line.Chart.Jitter.Title": "Jitter",
    "TestSuite.Line.Chart.Loss.Aria": "Verloren metingen per seconde; in de laatste seconde {{up}} heen, {{down}} terug, {{unknown}} richting onbekend en {{late}} te laat.",
    "TestSuite.Line.Chart.Loss.Title": "Verloren metingen per seconde",
    "TestSuite.Line.Chart.Ping.Aria": "Ping per seconde, laatste mediaan {{p50}}, 95e percentiel {{p95}}, maximum {{max}}.",
    "TestSuite.Line.Chart.Ping.Title": "Ping",
    "TestSuite.Line.Chart.Upload.Aria": "Upload per seconde in kbit/s; in de laatste seconde doel {{target}}, verstuurd {{sent}}, ontvangen {{received}}.",
    "TestSuite.Line.Chart.Upload.Title": "Uploadbelasting",
    "TestSuite.Line.Chart.WholeRun": "Toon de hele meting",
    "TestSuite.Line.Collecting": "De eerste resultaten verschijnen over een paar seconden.",
    "TestSuite.Line.Figure.Jitter": "Jitter",
    "TestSuite.Line.Figure.Loss": "Verlies",
    "TestSuite.Line.Figure.Ping": "Ping",
    "TestSuite.Line.Figure.Recent": "laatste 10 s",
    "TestSuite.Line.Figure.Silence": "Langste stilte",
    "TestSuite.Line.Figure.WholeRun": "hele meting",
    "TestSuite.Line.Heading": "Lijnkwaliteit",
    "TestSuite.Line.Intro": "Deze test meet seconde voor seconde de verbinding tussen deze computer en onze servers: vertraging (ping), jitter en pakketverlies. Hij heeft geen camera of microfoon nodig, dus je kunt hem draaien op de computer die je uitzending verstuurt, zoals de encoder-pc in een studio.",
    "TestSuite.Line.Legend.Background": "gemeten in een achtergrondtabblad",
    "TestSuite.Line.Legend.Down": "terug",
    "TestSuite.Line.Legend.Late": "te laat (TCP)",
    "TestSuite.Line.Legend.LoadChange": "belasting gewijzigd",
    "TestSuite.Line.Legend.Max": "maximum",
    "TestSuite.Line.Legend.Median": "mediaan",
    "TestSuite.Line.Legend.P95": "95e percentiel",
    "TestSuite.Line.Legend.Received": "ontvangen",
    "TestSuite.Line.Legend.Sent": "verstuurd",
    "TestSuite.Line.Legend.Stalled": "browser haperde",
    "TestSuite.Line.Legend.Target": "doel",
    "TestSuite.Line.Legend.Unknown": "richting onbekend",
    "TestSuite.Line.Legend.Unmeasured": "niet gemeten",
    "TestSuite.Line.Legend.Up": "heen",
    "TestSuite.Line.Load.Help": "Verstuurt naast de meting een stroom zo zwaar als een uitzending in die kwaliteit, om te zien of je lijn het onder belasting houdt. Je kunt dit wijzigen terwijl de test loopt.",
    "TestSuite.Line.Load.High": "Hoog",
    "TestSuite.Line.Load.Legend": "Uploadbelasting",
    "TestSuite.Line.Load.Low": "Laag",
    "TestSuite.Line.Load.Medium": "Gemiddeld",
    "TestSuite.Line.Load.Mixed": "Gemengd",
    "TestSuite.Line.Load.Off": "Uit",
    "TestSuite.Line.Load.Rate": "{{mbps}} Mbit/s, ongeveer {{mb}} MB per vijf minuten",
    "TestSuite.Line.LoadStatus.Connecting": "De uploadbelasting start…",
    "TestSuite.Line.LoadStatus.LoadBudget": "De belastingstest is bezet, probeer het over een minuut opnieuw.",
    "TestSuite.Line.LoadStatus.NotAllowed": "De belastingstest is niet beschikbaar voor dit account.",
    "TestSuite.Line.LoadStatus.NotUdp": "UDP is niet beschikbaar op dit netwerk, dus de belastingstest kan niet draaien.",
    "TestSuite.Line.LoadStatus.Other": "De uploadbelasting is gestopt ({{reason}}); over een minuut volgt een nieuwe poging.",
    "TestSuite.Line.LoadStatus.Running": "De uploadbelasting loopt.",
    "TestSuite.Line.NoValue": "geen",
    "TestSuite.Line.Status.Connecting": "Verbinden…",
    "TestSuite.Line.Status.Failed": "Meten is niet mogelijk ({{reason}}). Over een minuut volgt een nieuwe poging.",
    "TestSuite.Line.Status.Measuring": "Bezig met meten",
    "TestSuite.Line.Status.Stopped": "Gestopt",
    "TestSuite.Line.Status.Tcp": "UDP-meting niet beschikbaar op dit netwerk, er wordt gemeten via TCP.",
    "TestSuite.Line.Summary.Col.Background": "Achtergrondtabblad (s)",
    "TestSuite.Line.Summary.Col.Coverage": "Gemeten / gestokt / geblokkeerd / geen sessie (s)",
    "TestSuite.Line.Summary.Col.Echoed": "Teruggekomen",
    "TestSuite.Line.Summary.Col.Jitter": "Jitter p50 / p95 (ms)",
    "TestSuite.Line.Summary.Col.JitterUp": "Jitter heen p50 / p95 (ms)",
    "TestSuite.Line.Summary.Col.Late": "Te laat",
    "TestSuite.Line.Summary.Col.Load": "Belasting",
    "TestSuite.Line.Summary.Col.Lost": "Verloren heen / terug / onbekend",
    "TestSuite.Line.Summary.Col.Rtt": "Ping p50 / p95 / max (ms)",
    "TestSuite.Line.Summary.Col.Sent": "Verstuurd",
    "TestSuite.Line.Summary.Col.Silence": "Langste stilte (ms)",
    "TestSuite.Line.Summary.Col.Target": "Server",
    "TestSuite.Line.Summary.Col.Transport": "Transport",
    "TestSuite.Line.Summary.Col.Upload": "Upload verstuurd / ontvangen (kbit/s)",
    "TestSuite.Line.Summary.Col.Window": "Venster",
    "TestSuite.Line.Summary.Empty": "Het eerste venster van 10 seconden verschijnt ongeveer 13 seconden na de start.",
    "TestSuite.Line.Summary.Heading": "Samenvatting",
    "TestSuite.Line.Summary.Intro": "Dit zijn de waarden die naar onze servers gaan, per venster van 10 seconden. Voor de hele meting zijn de percentielen de mediaan van de vensters.",
    "TestSuite.Line.Summary.Mixed": "gemengd",
    "TestSuite.Line.Summary.WholeRun": "Hele meting",
    "TestSuite.Line.Summary.Windows": "Alle vensters ({{count}})",
    "TestSuite.Line.Target": "Server {{target}}",
    "TestSuite.PageHeading": "Maak je klaar voor je webinar",
    "TestSuite.Chooser.Camera.Title": "Camera en microfoon",
    "TestSuite.Chooser.Camera.Description": "Controleert of je camera, microfoon en verbinding samen goed werken voor een livestream. Gebruik dit om te oefenen voor je webinar.",
    "TestSuite.Chooser.Camera.Link": "Test camera en microfoon",
    "TestSuite.Chooser.Line.Title": "Lijnkwaliteit",
    "TestSuite.Chooser.Line.Description": "Meet hoe stabiel je internetverbinding is: vertraging, jitter en pakketverlies. Gebruik dit als kijkers haperingen of onderbrekingen melden, of om een nieuwe locatie te controleren.",
    "TestSuite.Chooser.Line.Link": "Test lijnkwaliteit",
    "TestSuite.PlayerConnection.Error": "Er is een fout opgetreden bij het verbinden van de speler video. Vernieuw de pagina.",
    "TestSuite.PlayerConnection.Live": "Live",
    "TestSuite.PlayerConnection.NotLive": "Niet live",
    "TestSuite.PlayerState.Buffering": "Bufferen",
    "TestSuite.PlayerState.Paused": "Gepauzeerd",
    "TestSuite.PlayerState.Playing": "Afspelen",
    "TestSuite.Progress.Label": "Testen",
    "TestSuite.State.Label": "Status:",
    "TestSuite.Text.Disclaimer": "<em>Let op:</em> De test geeft een momentopname. <br/>Verander je later iets aan je internetverbinding of de kwaliteit van je netwerk? Draai de test dan nog even opnieuw om zeker te weten dat alles goed werkt.",
    "TestSuite.Text.Explanation": "Links zie je je bronvideo en rechts wat je kijkers zien. Er zit een kleine vertraging tussen jouw video en de video die de kijkers zien.",
    "TestSuite.Text.PreTest": "Met deze test kun je controleren of je verbinding goed werkt met de servers van OnlineWebinar. We kijken één minuut lang of beeld en geluid goed doorkomen.<br/>Gebruik voor deze test dezelfde computer en camera als die je tijdens de uitzending gebruikt.",
    "TestSuite.Text.TestEnded": "De test is beëindigd. Als alles er goed uitziet, ben je klaar om je webinar te starten!",
    "TestSuite.Text.RetryTest": "Herstart de test",
    "TestSuite.Transport.Label": "Verbindingstype:",
    "TestSuite.Transport.Moq": "Media over QUIC ({{transport}})",
    "TestSuite.Transport.MoqUnknown": "Media over QUIC",
    "TestSuite.Transport.Classic": "Klassieke verbinding (WebRTC)",
    "TestSuite.Transport.MoqFailed": "Media over QUIC lukte niet; de test gaat verder via de klassieke verbinding.",
    "TestSuite.ApiErrorCode.NotReadyException": "Probeer het later opnieuw.",
    "TestSuite.ApiErrorCode.NotReadyException.Body": "Er zijn momenteel geen testkanalen beschikbaar. Probeer het later opnieuw.",
    "Title.ForWebinar": "{{page}} voor {{webinar}}",
    "Title.RegisterForWebinar": "Registreren voor {{webinar}}",
    "Title.WatchWebinar": "{{webinar}} bekijken",
    "Title.EditWebinar": "{{webinar}} bewerken",
    "Title.Upcoming": "Overzicht aankomende webinars",
    "Title.OnDemand": "Overzicht on demand webinars",
    "Title.VerifyAccount": "Account verifiëren",
    "Title.Unsubscribe": "Afmelden",
    "Title.NotFound": "Pagina niet gevonden",
    "Title.AccountManagerInvite": "Uitnodiging als accountmanager",
    "Title.BroadcastWebinar": "{{webinar}} uitzenden",
    "Title.Moderator": "Moderator",
    "Title.SlideController": "Slidebediening",
    "Title.DeleteWebinar": "{{webinar}} verwijderen",
    "Title.ShareWebinar": "{{webinar}} delen",
    "Title.Content": "Inhoud",
    "Title.Analytics": "Analyse",
    "Title.OrganizedUpcoming": "Georganiseerde aankomende webinars",
    "Title.OrganizedEnded": "Georganiseerde afgelopen webinars",

    "Translation.InfoText": "Het bijgewerkte vertaalbestand moet een JSON-vertaalbestand of een Excel-bestand zijn. Het Excel-bestand moet twee kolommen hebben, de eerste kolom moet de sleutel bevatten en de tweede kolom de vertaling. De eerste rij moet de kopteksten “Key” en “Translation” bevatten.",
    "Translation.PageHeading": "Beheer vertaling",
    "Translation.Table.Header.Key": "Sleutel",
    "Translation.Table.Header.Translation": "Vertaling",

    "Validation.Email.Required": "Het e-mailadres is niet ingevuld.",
    "Validation.Email.Invalid": "Het e-mailadres is ongeldig. Een geldig e-mailadres heeft een @ en daarna een domeinnaam met een punt, zonder spaties. Bijvoorbeeld: naam@voorbeeld.nl",
    "Validation.Email.MaxLength": "Een e-mail kan maximaal 245 tekens bevatten.",
    "Validation.CompanyName.MaxLength": "De bedrijfsnaam kan maximaal 100 tekens bevatten.",
    "Validation.ForgotPasswordCode.Required": "De code is niet ingevuld.",
    "Validation.Password.Required": "Het wachtwoord is niet ingevuld.",
    "Validation.Password.ComplexityScore0": "Het wachtwoord is zeer zwak. Gebruik een sterker wachtwoord.",
    "Validation.Password.ComplexityScore1": "Het wachtwoord is zwak. Gebruik een sterker wachtwoord.",
    "Validation.Password.ComplexityScore2": "Het wachtwoord is matig. Gebruik een sterker wachtwoord.",
    "Validation.Password.ComplexityScore3": "Het wachtwoord is sterk.",
    "Validation.Password.ComplexityScore4": "Het wachtwoord is zeer sterk.",
    "Validation.Nickname.Required": "De nickname is niet ingevuld.",
    "Validation.Nickname.MinLength": "Nickname moet minimaal 3 tekens bevatten.",
    "Validation.Nickname.MaxLength": "Nickname kan maximaal 70 tekens bevatten.",
    "Validation.FirstName.Required": "De voornaam is niet ingevuld.",
    "Validation.FirstName.MaxLength": "Voornaam kan maximaal 35 tekens bevatten.",
    "Validation.LastName.Required": "De achternaam is niet ingevuld.",
    "Validation.LastName.MaxLength": "Achternaam kan maximaal 35 tekens bevatten.",
    "Validation.TermsOfAgreement.Required": "Je moet akkoord gaan met de algemene voorwaarden.",

    "Video.Initializing": "We initialiseren audio en video. Sta alsjeblieft toegang toe tot je camera en microfoon wanneer daarom wordt gevraagd.",

    "Viewer.Message.Button.InterestedOverview": "Aangemelde webinars",
    "Viewer.Message.MultipleSessions": "Het lijkt erop dat u dit webinar bekijkt in een ander browservenster, op een ander tabblad of op een ander apparaat.<br />U kunt deze pagina vernieuwen om hier verder te kijken.",
    "Viewer.Message.TestWebinarFull": "Dit testwebinar heeft het maximum van {{maxViewers}} kijkers bereikt.",
    "Viewer.Message.WebinarCancelled": "Het webinar dat je wilt bekijken, is geannuleerd.",
    "Viewer.Message.WebinarExpired": "Het webinar dat je wilt bekijken heeft niet plaatsgevonden.",
    "Viewer.Message.WebinarPlanned": "Dit webinar begint over",
    "Viewer.Message.WebinarNotStarted": "Het webinar is nog niet begonnen, nog even wachten ajb.",
    "Maintenance.Notice.Title": "Onderhoud",
    "Maintenance.Gateway.Title": "Onderhoud bezig",
    "Maintenance.Gateway.Body": "Het platform is tijdelijk niet beschikbaar wegens onderhoud. Deze pagina gaat vanzelf verder zodra het platform terug is.",
    "Viewer.Message.ConnectionLost": "De verbinding met het webinar is verloren. Controleer uw internetverbinding en vernieuw de pagina.",
    "Viewer.Message.ConnectionConnecting": "Verbinden met het webinar, even geduld...",

    "WebinarAnalytics.Heading.AudioPackets": "Audio packets verzonden",
    "WebinarAnalytics.Heading.AudioScore": "Audioscore",
    "WebinarAnalytics.Heading.BytesSent": "Verzonden bytes",
    "WebinarAnalytics.Heading.PacketDelay": "Packet vertraging",
    "WebinarAnalytics.Heading.RetransmittedPackets": "Opnieuw verzonden packets",
    "WebinarAnalytics.Heading.VideoPackets": "Video packets verzonden",
    "WebinarAnalytics.Heading.VideoScore": "Videoscore",
    "WebinarAnalytics.PageHeading": "Webinar analyse",

    "WebinarButton.Status.Cancelled": "Bekijk details",
    "WebinarButton.Status.Ended": "Insights",
    "WebinarButton.Status.Expired": "Webinar bewerken",
    "WebinarButton.Status.Started": "Broadcast",
    "WebinarButton.Status.Planned": "Broadcast",

    "Webinar.Button.Reschedule": "Opnieuw inplannen",
    "Webinar.Data.Attachment": "bijlagen",
    "Webinar.Data.Exam": "examen",
    "Webinar.Data.Heading": "Status",
    "Webinar.Data.Status.NotEnabled": "Nee",
    "Webinar.Data.Status.Enabled": "Ja",
    "Webinar.Data.Status.NotValid": "Niet geldig",
    "Webinar.Data.Chapters": "hoofdstukken",
    "Webinar.Data.Interested": "geïnteresseerden",
    "Webinar.Data.OndemandViews": "on demand weergaven",
    "Webinar.Data.Polls": "polls",
    "Webinar.Data.Security": "beveiliging",
    "Webinar.Data.Slides": "slides",
    "Webinar.Data.Survey": "enquête",
    "Webinar.Data.Viewers": "kijkers",
    "Webinar.DateTime.StartIn": "Start in:",
    "Webinar.DateTime.StartNow": "Nu starten",
    "Webinar.Live": "Live",
    "Webinar.StatusMessage.Cancelled": "Dit webinar is <span>geannuleerd</span>.",
    "Webinar.StatusMessage.Expired": "Dit webinar is <span>verlopen</span>.",
    "Webinar.StatusMessage.Timeslot": "Het geselecteerde tijdslot voor dit webinar is niet beschikbaar! <span>Plan uw webinar opnieuw!</span>",
    "Webinar.Visibility.Private": "Privé",
    "Webinar.Warning.NotPublished": "Niet gepubliceerd.",
    "Webinar.Warning.NotPublished.Body": "Dit webinar is nog niet gepubliceerd en is niet beschikbaar voor kijkers.",
    "Webinar.Warning.NoBooking": "Tijdslot niet beschikbaar.",
    "Webinar.Warning.NoBooking.Body": "Er is geen tijdslot beschikbaar voor dit webinar. U kunt het webinar niet uitzenden.",
    "Webinar.Warning.Dangerzone": "Gevarenzone",
    "Webinar.Button.Cancel": "Annuleer webinar",
    "Webinar.Button.Delete": "Verwijder dit webinar",
    "Webinar.Delete.Deletecode.Label": "Bevestig delete code",
    "Webinar.Delete.DeleteCode": "Vul de getoonde delete code in om te bevestigen dat u dit webinar wilt verwijderen. Let op, deze is hoofdletter gevoelig.",
    "Webinar.Delete.PageHeading": "Verwijder webinar",
    "Webinar.Delete.Warning": "Weet u zeker dat u dit webinar wilt verwijderen? Dit is permanent en kan niet ongedaan worden gemaakt.",
    "Webinar.Warning.WebinarIsCancelled": "Dit webinar is geannuleerd.",
    "Webinar.Warning.WebinarIsCancelled.Body": "Dit webinar is geannuleerd en kan niet worden bekeken maar is nog wel zichtbaar.",
    "Webinar.CancelWebinar.Title": "Annuleer webinar",
    "Webinar.CancelWebinar.Description": "Weet u zeker dat u dit webinar wilt annuleren? Dit kan niet ongedaan worden gemaakt.",
    "Webinar.CancelWebinar.Button.Close": "Nee",
    "Webinar.CancelWebinar.Button.Cancel": "Ja, annuleer webinar",
    "Webinar.RescheduleWebinar.Title": "Webinar opnieuw inplannen",
    "Webinar.RescheduleWebinar.Description": "U bent verantwoordelijk voor het informeren van de deelnemers over de nieuwe uitzenddatum en -tijd. Wilt u doorgaan?",
    "Webinar.Test.Badge": "Testwebinar",
    "Webinar.Test.Switch.Label": "Dit is een testwebinar",
    "Webinar.Test.Confirm.Title": "Plannen als testwebinar?",
    "Webinar.Test.Confirm.Description": "Een testwebinar duurt maximaal {{maxDurationMinutes}} minuten, laat maximaal {{maxViewers}} kijkers toe en wordt niet gefactureerd. Het wordt {{deleteAfterStartHours}} uur na de geplande start automatisch verwijderd, inclusief de opname, en kan daarna niet in een echt webinar worden omgezet.",
    "Webinar.Test.Confirm.Button.Confirm": "Ja, plan een testwebinar",
    "Webinar.Test.Confirm.Button.Close": "Nee",
    "Webinar.Test.Notice.Title": "Dit is een testwebinar",
    "Webinar.Test.Notice.Body": "Maximaal {{maxDurationMinutes}} minuten en {{maxViewers}} kijkers, wordt niet gefactureerd.",
    "Webinar.Test.Notice.DeleteOn": "Het wordt na {{deleteOn}} automatisch verwijderd, inclusief de opname.",
    "Webinar.Test.DeleteOn": "Wordt na {{deleteOn}} automatisch verwijderd",
    "Webinar.Test.Countdown.Limit": "Testwebinar: de uitzending stopt automatisch na {{maxDurationMinutes}} minuten",
    "Webinar.Test.Countdown.Ending": "Testwebinar: stopt automatisch over",
    "Webinar.Schedule.Warning.TestDurationMaximum": "Een testwebinar mag maximaal {{maxDuration}} minuten duren",

    "WebinarDetails.Button.NoLongerInterested": "Niet langer geïnteresseerd",
    "WebinarDetails.Button.Interested": "Geïnteresseerd",
    "WebinarDetails.Button.UploadBannerImage.AriaLabel": "Upload bannerafbeelding voor dit webinar",
    "WebinarDetails.Button.UploadProfileImage.AriaLabel": "Upload profielafbeelding voor dit webinar",
    "WebinarDetails.Button.UseDefaultBannerImage.AriaLabel": "Verwijder de afbeelding en gebruik de standaard bannerafbeelding",
    "WebinarDetails.Button.UseDefaultProfileImage.AriaLabel": "Verwijder de afbeelding en gebruik de standaard profielafbeelding",
    "WebinarDetails.Button.UseDefaultImage": "Gebruik standaard",
    "WebinarDetails.Button.WatchIn": "Bekijk over {{watchCountdown}}",
    "WebinarDetails.Button.VerifyToWatch": "Verifieer om te kijken",
    "WebinarDetails.By": "door",
    "WebinarDetails.Label.Date": "Datum",
    "WebinarDetails.Label.Duration": "Duur",
    "WebinarDetails.Label.Host": "Spreker",
    "WebinarDetails.Label.Time": "Tijd",
    "WebinarDetails.Label.Visibility.Private": "Privé webinar: dit webinar is alleen zichtbaar voor mensen die een uitnodiging of een deellink hebben ontvangen.",
    "WebinarDetails.Label.Visibility.Public": "Publiek webinar: dit webinar zal zichtbaar zijn in het overzicht.",
    "WebinarDetails.Legend.Visibility": "Webinar zichtbaarheid",
    "WebinarDetails.Section.OnDemand": "On-demand",
    "WebinarDetails.Label.OnDemand.Enabled": "Sta kijkers toe de on-demand te bekijken",
    "WebinarDetails.Info.OnDemandPreparing": "Je opname wordt voorbereid. Kom binnenkort terug.",
    "Content.OnDemand.Status.Processing": "Verwerken",
    "Content.OnDemand.Status.Available": "Beschikbaar",
    "Content.OnDemand.Status.Failed": "Mislukt",
    "WebinarDetails.Link.BackToOverview": "Terug naar aankomende webinars",
    "WebinarDetails.Heading.Attachments": "Bijlagen",
    "WebinarDetails.Heading.Related": "Beluister dit webinar als podcast",
    "WebinarDetails.Warning.AccessRestricted": "Toegang tot dit webinar is beperkt.",
    "WebinarDetails.Warning.LinkExpired": "Uw persoonlijke link is verlopen.",
    "WebinarDetails.Warning.OnDemandNotAvailable": "Het webinar is beeindigd en is niet beschikbaar als OnDemand.",

    "WebinarDurationSettings.Figure.ChannelAllocation": "Toewijzing kanaal",
    "WebinarDurationSettings.Figure.ChannelInUse": "Kanaal in gebruik",
    "WebinarDurationSettings.Figure.PlannedDuration": "Geplande duur",
    "WebinarDurationSettings.Figure.PlannedEndTime": "Geplande eindtijd webinar",
    "WebinarDurationSettings.Figure.PlannedStartTime": "Geplande starttijd van het webinar",
    "WebinarDurationSettings.Figure.RunOutTime": "Uitlooptijd",
    "WebinarDurationSettings.InfoText": "<p>Voor het geven van een webinar wordt een kanaal gereserveerd. Voor hoe lang dit is, hangt af van drie zaken:</p> <ul><li>De tijd voor de geplande starttijd wanneer het kanaal wordt toegewezen. Vanaf dit moment kan de uitzending gestart worden.</li><li>De geplande duur van het webinar.</li><li>De uitloop tijd na de geplande duur van het webinar.</li></ul><p></p>",
    "WebinarDurationSettings.PageHeading": "Instellingen voor de duur van webinars",
    "WebinarDurationSettings.Text.DurationAfterEnd": "Extra uitlooptijd na de geplande eindtijd:",
    "WebinarDurationSettings.Text.DurationBeforeStart": "Tijd dat het kanaal is toegewezen vóór de geplande starttijd:",
    "WebinarDurationSettings.Text.MaxDuration": "De maximaal geplande duur van een webinar:",
    "WebinarDurationSettings.Text.TotalDuration": "De totale maximale duur van een webinar:",

    "webinarProgress.failedToLoadStreamText": "Het laden van de videostream is mislukt.",

    "Webinar.Schedule.Label.BroadcastDate": "Uitzenddatum",
    "Webinar.Schedule.Label.ClientReference": "Klantreferentie",
    "Webinar.Schedule.Label.Description": "Omschrijving",
    "Webinar.Schedule.Label.Duration": "Duur",
    "Webinar.Schedule.Label.HostName": "Naam van de spreker",
    "Webinar.Schedule.Label.Title": "Titel van het webinar",
    "Webinar.Schedule.PageHeading": "Plan uw webinar",
    "Webinar.Edit.PageHeading": "Webinar bewerken",
    "Webinar.Schedule.Warning.DateFuture": "De uitzenddatum moet in de toekomst liggen",
    "Webinar.Schedule.Warning.DateRequired": "Uitzenddatum is vereist",
    "Webinar.Schedule.Warning.DurationMaximum": "Selecteer een duur die niet langer is dan {{maxDuration}}",
    "Webinar.Schedule.Warning.DurationMinimum": "De minimale duur is {{minDuration}} minuten",
    "Webinar.Schedule.Warning.NameMax": "Naam mag niet langer zijn dan 350 tekens",
    "Webinar.Schedule.Warning.NameMin": "Naam moet minimaal 3 tekens lang zijn",
    "Webinar.Schedule.Warning.NameRequired": "Name is required",
    "Webinar.Schedule.Warning.Timeslot": "Het gevraagde tijdslot is niet beschikbaar",
    "Webinar.Schedule.Warning.TitleMax": "De titel mag niet langer zijn dan 350 tekens",
    "Webinar.Schedule.Warning.TitleMin": "De titel moet minimaal 3 tekens lang zijn",
    "Webinar.Schedule.Warning.TitleRequired": "Titel is vereist",

    "WebinarUpNext.Button.Share": "Delen",
    "WebinarUpNext.Button.StartBroadcast": "Start broadcast",
    "WebinarUpNext.Button.Test": "Test verbinding",
    "WebinarUpNext.Heading.UpNext": "Up next",

    "Javascript.Required": "Deze applicatie vereist JavaScript om te kunnen functioneren. Schakel JavaScript in uw browserinstellingen in en vernieuw de pagina.",

    "Manage.Link.EmailLists": "Beheer e-maillijsten",
    "Manage.Link.Blacklist": "Beheer blacklist",

    "EmailLists.PageHeading": "E-maillijsten",
    "EmailLists.Button.Import": "Een nieuwe lijst importeren",
    "EmailLists.Button.BackToLists": "Terug naar e-maillijsten",
    "EmailLists.Button.BackToCampaign": "Terug naar de campagne",
    "EmailLists.Heading.YourLists": "Uw e-maillijsten",
    "EmailLists.Table.Header.Description": "Omschrijving",
    "EmailLists.Table.Header.ImportedDate": "Geïmporteerd op",
    "EmailLists.Table.Header.RecipientCount": "Ontvangers",
    "EmailLists.Table.Header.SendCount": "Verzendingen",
    "EmailLists.Table.Header.LastSendAt": "Laatst verzonden",
    "EmailLists.Table.Header.Status": "Status",
    "EmailLists.Status.Importing": "Importeren",
    "EmailLists.Status.Active": "Actief",
    "EmailLists.Status.Deleted": "Verwijderd",
    "EmailLists.Import.PageHeading": "Een nieuwe e-maillijst importeren",
    "EmailLists.Import.Label.Description": "Omschrijving van de lijst",
    "EmailLists.Import.Button.Import": "Lijst importeren",
    "EmailLists.Import.Error.DescriptionRequired": "Voer een omschrijving in voor deze lijst",
    "EmailLists.Detail.ImportedDate": "Geïmporteerd op",
    "EmailLists.Detail.RecipientCount": "Ontvangers",
    "EmailLists.Detail.Status": "Status",
    "EmailLists.Detail.Button.Send": "E-mail versturen",
    "EmailLists.Detail.Button.Delete": "Lijst verwijderen",
    "EmailLists.Detail.SendLog.Heading": "Verzendgeschiedenis",
    "EmailLists.Detail.SendLog.Empty": "Er zijn nog geen e-mails naar deze lijst verstuurd.",
    "EmailLists.Detail.Campaigns.Heading": "Marketingcampagnes",
    "EmailLists.Detail.Campaigns.Name": "Campagne",
    "EmailLists.Detail.Campaigns.UsedAt": "Verstuurd op",
    "EmailLists.Detail.Campaigns.View": "Campagne bekijken",
    "EmailLists.Detail.SendLog.TemplateType": "Type",
    "EmailLists.Detail.SendLog.SentAt": "Verstuurd op",
    "EmailLists.Detail.SendLog.RecipientCount": "Ontvangers",
    "EmailLists.Detail.SendLog.SentCount": "Verzonden",
    "EmailLists.Detail.SendLog.FailedCount": "Mislukt",
    "EmailLists.Detail.SendLog.BlacklistedCount": "Op blacklist",
    "EmailLists.Detail.SendLog.Actions": "Details",
    "EmailLists.Detail.SendLog.AlreadyInterestedCount": "Al geïnteresseerd",
    "EmailLists.Detail.SendLog.ViewTemplate": "E-mail bekijken",
    "EmailLists.Detail.Tab.Members": "Ontvangers",
    "EmailLists.Detail.Tab.SendHistory": "Verzendgeschiedenis",
    "EmailLists.Detail.Description.Label": "Omschrijving van de lijst",
    "EmailLists.Detail.Description.Edit": "Omschrijving bewerken",
    "EmailLists.Detail.Members.Empty": "Deze lijst heeft nog geen ontvangers.",
    "EmailLists.Detail.Members.Header.Email": "E-mailadres",
    "EmailLists.Detail.Members.Header.Name": "Naam",
    "EmailLists.Detail.Members.Header.Company": "Bedrijf",
    "EmailLists.Detail.Members.RemoveLabel": "{{email}} uit de lijst verwijderen",
    "EmailLists.Detail.Members.RemoveTitle": "Ontvanger verwijderen?",
    "EmailLists.Detail.Members.RemoveBody": "Weet u zeker dat u {{email}} uit deze lijst wilt verwijderen?",
    "EmailLists.Detail.Members.RemoveConfirm": "Verwijderen",
    "EmailLists.Detail.Members.Locked": "Deze lijst is al gebruikt om e-mail te versturen, dus de ontvangers kunnen niet meer worden gewijzigd.",
    "EmailLists.Detail.Append.Heading": "Meer ontvangers toevoegen",
    "EmailLists.Detail.Append.Intro": "Importeer nog een bestand om ontvangers aan deze lijst toe te voegen. Dubbele e-mailadressen worden automatisch overgeslagen.",
    "EmailLists.Detail.Append.Button": "Aan lijst toevoegen",
    "EmailLists.TemplateType.EmailList": "Algemene e-mail",
    "EmailLists.TemplateType.WebinarEmailList": "Webinar e-mail",
    "EmailLists.Send.Title": "Een e-mail naar deze lijst versturen",
    "EmailLists.Send.TemplateTypeLabel": "Welke e-mail wilt u versturen?",
    "EmailLists.Send.WebinarLabel": "Kies een webinar",
    "EmailLists.Send.WebinarPlaceholder": "Selecteer een webinar...",
    "EmailLists.Send.WebinarGroup.Upcoming": "Aankomende webinars",
    "EmailLists.Send.WebinarGroup.Ended": "Afgelopen webinars",
    "EmailLists.Send.AlreadySentWarning": "Dit type e-mail is al naar deze lijst verstuurd.",
    "EmailLists.Send.AudienceHeading": "Doelgroep",
    "EmailLists.Send.ExcludeInterested": "Accounts die al interesse hebben in dit webinar uitsluiten",
    "EmailLists.Send.AlreadyInterested": "Al geïnteresseerd",
    "EmailLists.Send.AlreadyInterestedSummary": "{{count}} van de {{total}} ontvangers zijn al geïnteresseerd in dit webinar",
    "EmailLists.Send.ExcludedSuffix": "zij worden uitgesloten van deze verzending",
    "EmailLists.Send.PublishWebinarFirst": "Publiceer het webinar voordat u kunt versturen.",
    "EmailLists.Send.SubjectLabel": "Onderwerp",
    "EmailLists.Send.BodyLabel": "Bericht",
    "EmailLists.Send.Confirm": "Versturen",
    "EmailLists.View.Title": "Verstuurde e-mail",
    "EmailLists.Delete.Title": "Deze e-maillijst verwijderen?",
    "EmailLists.Delete.Body.Unused": "Hiermee verwijdert u de lijst en al haar ontvangers definitief. Deze actie kan niet ongedaan worden gemaakt.",
    "EmailLists.Delete.Body.Used": "Deze lijst is al gebruikt om e-mail te versturen. De persoonsgegevens van de ontvangers worden gewist, maar een overzicht van de verzendingen blijft bewaard voor uw audithistorie. Deze actie kan niet ongedaan worden gemaakt.",
    "EmailLists.Delete.Confirm": "Lijst verwijderen",

    "Blacklist.PageHeading": "Blacklist",
    "Blacklist.Search.Label": "Zoek op e-mailadres",
    "Blacklist.Search.Placeholder": "Zoeken...",
    "Blacklist.Table.Header.Email": "E-mailadres",
    "Blacklist.Table.Header.BlacklistedAt": "Op blacklist sinds",
    "Blacklist.Table.Header.Source": "Bron",
    "Blacklist.Source.UnsubscribeLink": "Afmeldlink",
    "Blacklist.Source.AdminUi": "Beheerder",
    "Blacklist.Source.ProfileToggle": "Profielinstelling",
    "Blacklist.Button.Remove": "Verwijder {{email}} van de blacklist",
    "Blacklist.Empty": "Geen e-mailadressen op de blacklist gevonden.",
    "Blacklist.Remove.Title": "Van de blacklist verwijderen?",
    "Blacklist.Remove.Body": "Weet u zeker dat u {{email}} van de blacklist wilt verwijderen?",
    "Blacklist.Remove.Confirm": "Verwijderen",

    "Unsubscribe.Error.Title": "Er is iets misgegaan",
    "Unsubscribe.Success.Title": "U bent afgemeld",
    "Unsubscribe.Success.Body": "U ontvangt geen ongevraagde e-mail meer van {{brand}}.",
    "Unsubscribe.Resubscribe.Prompt": "Was dit niet de bedoeling?",
    "Unsubscribe.Resubscribe.Button": "Opnieuw aanmelden",
    "Unsubscribe.Resubscribed.Title": "U bent opnieuw aangemeld",
    "Unsubscribe.Resubscribed.Body": "U ontvangt weer e-mail van {{brand}}.",

    "EmailPreferences.PageHeading": "E-mailvoorkeuren",
    "EmailPreferences.Description": "Beheer of u ongevraagde e-mail van deze omgeving ontvangt.",
    "EmailPreferences.Toggle.Label": "Meld mij af voor ongevraagde e-mail",

    "ChatLinkDomains.PageHeading": "Chat-linkdomeinen",
    "ChatLinkDomains.Intro": "Links in chatberichten openen direct voor domeinen op de toegestane lijst; elke andere link toont eerst een waarschuwing. Domeinen op de geblokkeerde lijst kunnen niet worden geplaatst, en links ernaar in oudere berichten zijn niet meer klikbaar. Elke link wordt nog steeds gecontroleerd op malware en phishing, ook links op de toegestane lijst — de toegestane lijst drukt vertrouwen uit, ook voor links uit het verleden. Zet geen URL-verkorters of sites met open redirects op de toegestane lijst.",
    "ChatLinkDomains.AllowedDomains.Label": "Toegestane domeinen",
    "ChatLinkDomains.AllowedDomains.Help": "Eén domein per regel, bijvoorbeeld example.com. Subdomeinen tellen mee.",
    "ChatLinkDomains.BlockedDomains.Label": "Geblokkeerde domeinen",
    "ChatLinkDomains.BlockedDomains.Help": "Eén domein per regel. Een geblokkeerd subdomein wint van een toegestaan hoofddomein.",
    "ChatLinkDomains.Save": "Opslaan",
    "ChatLinkDomains.Save.Success": "De domeinlijsten zijn opgeslagen.",
    "ChatLinkDomains.Save.Error": "De domeinlijsten konden niet worden opgeslagen.",
    "Manage.Link.ChatLinkDomains": "Beheer chat-linkdomeinen",
    "Chat.Message.LinkNotAllowed": "Je bericht kon niet worden verzonden omdat het een link bevat die niet is toegestaan. Pas de link aan of verwijder hem en probeer het opnieuw.",
    "Chat.Message.TooManyLinks": "Een bericht mag maximaal 10 links bevatten.",
    "Chat.LinkWarning.Title": "Ongeverifieerde link",
    "Chat.LinkWarning.Body": "Deze link leidt naar een website die wij niet hebben geverifieerd. Wil je doorgaan naar <strong>{{hostname}}</strong>? De link wordt geopend in een nieuw tabblad.",
    "Chat.LinkWarning.Continue": "Doorgaan",
    "Manage.Link.UsageStatistics": "Gebruik bekijken",
    "UsageStatistics.PageHeading": "Gebruiksstatistieken",
    "UsageStatistics.Range.ThisMonth": "Deze maand",
    "UsageStatistics.Range.LastMonth": "Vorige maand",
    "UsageStatistics.Range.ThisQuarter": "Dit kwartaal",
    "UsageStatistics.Range.ThisYear": "Dit jaar",
    "UsageStatistics.Today.Heading": "Vandaag tot nu toe",
    "UsageStatistics.Provisional": "Vandaag is nog niet bevroren: deze cijfers zijn voorlopig en tellen niet mee in de periodetotalen of de export.",
    "UsageStatistics.DaysMissing": "Van {{count}} dag(en) in deze periode zijn nog geen gegevens beschikbaar.",
    "UsageStatistics.ApproximateOnDemand": "Publicatiedatums van on-demand webinars van vóór de ingebruikname zijn benaderd op basis van de uitzenddatum.",
    "UsageStatistics.Export": "Exporteren naar Excel",
    "UsageStatistics.StockDelta": "{{change}} in deze periode",
    "UsageStatistics.NoStockBaseline": "Er zijn geen gegevens over de dag vóór deze periode, waardoor de verandering over de periode niet getoond kan worden. De niveaus zelf zijn hierdoor niet beïnvloed.",
    "UsageStatistics.Metric.LiveWebinars": "Live webinars",
    "UsageStatistics.Metric.WebinarMinutes": "Webinarminuten",
    "UsageStatistics.Metric.LiveViewers": "Live deelnames",
    "UsageStatistics.Metric.LiveWatchMinutes": "Live kijkminuten",
    "UsageStatistics.Metric.OnDemandViewers": "On-demand kijksessies",
    "UsageStatistics.Metric.OnDemandWatchMinutes": "On-demand kijkminuten",
    "UsageStatistics.Metric.OnDemandCatalogue": "On-demand catalogus",
    "UsageStatistics.Metric.StorageBytes": "Gebruikte opslag (bytes)",
    "UsageStatistics.Metric.TestWebinars": "Testwebinars",
    "UsageStatistics.Filter.From": "Van",
    "UsageStatistics.Filter.To": "Tot en met",
    "UsageStatistics.Chart.LiveWebinarsPerWeek": "Live webinars per week",
    "UsageStatistics.Chart.NoData": "Nog geen bevroren dagen met gegevens in deze periode.",
    "UsageStatistics.Billing.Heading": "Factureerbare webinaruren",
    "UsageStatistics.Billing.BlockSize": "Geteld in blokken van {{size}} kijkers",
    "UsageStatistics.Billing.Allowance": "Afgesproken: {{hours}} uur per maand",
    "UsageStatistics.Billing.MonthsOver": "{{count}} van de afgelopen 12 maanden overschreden de afgesproken uren",
    "UsageStatistics.Billing.Webinar": "Webinar",
    "UsageStatistics.Billing.PeakViewers": "Piek aantal kijkers",
    "UsageStatistics.Billing.Blocks": "Blokken",
    "UsageStatistics.Billing.BillableMinutes": "Factureerbare minuten"
}
